export const contentGerman = {
  code: "DE",
  labels: {
    // App Digital Admin
    digitalAdmin: "Digital Admin",
    digitalAdminApp: "Digital Admin App",
    digitalAdminSarl: "Digital Admin SARL",
    copilotTitle: "Digital Copilot",
    copilotComingSoon: "Ihr KI-Assistent kommt bald",
    copilotOpen: "Copilot öffnen",
    copilotClose: "Copilot schließen",
    copilotPlaceholder: "Stellen Sie Ihrem KI-Assistenten eine Frage",
    copilotInputPlaceholder: "Nachricht eingeben...",
    copilotSend: "Senden",
    copilotConnected: "Verbunden",
    copilotConnecting: "Verbinden...",
    copilotDisconnected: "Getrennt",
    copilotConnectionLost: "Verbindung verloren",
    copilotReconnect: "Neu verbinden",
    copilotToolRunning: "Suche läuft",
    copilotActionProposed: "Vorgeschlagene Aktion",
    copilotConfirm: "Bestaetigen",
    copilotReject: "Ablehnen",
    copilotConfirming: "Wird bestaetigt...",
    copilotRejecting: "Wird abgelehnt...",
    copilotActionBlockInput: "Bestaetigen oder ablehnen Sie die vorgeschlagene Aktion",
    copilotActionHint: "Bestaetigen, ablehnen oder Korrektur eingeben",
    copilotActionCreateContact: "Neuer Kontakt",
    copilotActionCreateInvoice: "Neue Rechnung",
    copilotActionCreateQuote: "Neues Angebot",
    copilotActionCreateOrder: "Neue Bestellung",
    copilotActionCreateProviderInvoice: "Neue Lieferantenrechnung",
    copilotActionCreateProviderOrder: "Neue Lieferantenbestellung",
    copilotActionCreateExpense: "Neue Ausgabe",
    copilotActionCreateAccountingEntry: "Neuer Buchungssatz",
    copilotResultContactCreated: "Kontakt erstellt",
    copilotResultInvoiceCreated: "Rechnung erstellt",
    copilotResultQuoteCreated: "Angebot erstellt",
    copilotResultOrderCreated: "Bestellung erstellt",
    copilotResultProviderInvoiceCreated: "Lieferantenrechnung erstellt",
    copilotResultProviderOrderCreated: "Lieferantenbestellung erstellt",
    copilotResultExpenseCreated: "Ausgabe erstellt",
    copilotResultAccountingEntryCreated: "Buchungssatz erstellt",
    copilotResultGeneric: "Aktion ausgefuehrt",
    copilotResultFailed: "Die Aktion ist fehlgeschlagen",
    copilotDiscussDocument: "Mit Copilot besprechen",
    copilotDocumentAttached: "Angehaengtes Dokument",
    copilotDetachDocument: "Trennen",
    copilotViewPiece: "Dokument ansehen",
    copilotAttachDocument: "Dokument anhaengen",
    copilotSearchExisting: "Vorhandene suchen",
    copilotUploadNew: "Neue hochladen",
    copilotSearchPlaceholder: "Nach Name suchen...",
    copilotUploading: "Hochladen...",
    copilotUploadError: "Hochladen fehlgeschlagen",
    copilotNoDocuments: "Keine Dokumente gefunden",
    uploadingFile: "Datei wird hochgeladen...",
    uploadProgress: "Upload-Fortschritt",
    zipExtractionStarted: "ZIP-Extraktion gestartet",
    zipExtractionInProgress: "Ihre ZIP-Datei wird im Hintergrund extrahiert. Die Dokumente erscheinen in Kuerze.",
    uploadFailed: "Hochladen fehlgeschlagen",
    uploadTooLarge: "Die Datei ueberschreitet die maximal zulaessige Groesse",
    copilotOnline: "Online",
    copilotYou: "Sie",
    copilotHistory: "Verlauf",
    copilotNewConversation: "Neues Gespraech",
    copilotNoThreads: "Keine Gespraeche",
    copilotActionRejected: "Aktion abgelehnt",
    copilotActionFailedPast: "Aktion fehlgeschlagen",
    copilotLoadingMessages: "Nachrichten werden geladen...",
    copilotSuggestCreateExpense: "Ausgabe erstellen",
    copilotSuggestCreateProviderInvoice: "Lieferantenrechnung erstellen",
    copilotSuggestMsgCreateExpense: "Erstelle eine Ausgabe aus dem angehängten Dokument.",
    copilotSuggestMsgCreateProviderInvoice: "Erstelle eine Lieferantenrechnung aus dem angehängten Dokument.",
    copilotActionStartBatch: "Stapelverarbeitung",
    copilotBatchConfirmText: "Alle ausstehenden Dokumente automatisch verarbeiten. Der Copilot analysiert und erstellt die entsprechenden Einträge.",
    copilotBatchMilestone: "Stapelverarbeitung",
    copilotSuggestProcessDocuments: "Meine Dokumente verarbeiten",
    copilotSuggestMsgProcessDocuments: "Verarbeite automatisch alle meine ausstehenden Dokumente.",
    viewDocument: "Dokument anzeigen",
    digitalAdminPro: "Digital Admin Pro",
    welcomeToDigitalAdmin: "Willkommen bei Digital Admin",
    purchasePro: "Digital Admin Pro kaufen",
    signIn: "Bei Digital Admin anmelden",

    // Words sentences
    about: "Über",
    successful: "Erfolgreich",
    error: "Fehler",
    accountSettings: "Kontoeinstellungen",
    actions: "Aktionen",
    additional: "Zusätzlich",
    address: "Adresse",
    administrativeArea: "Kanton",
    amount: "Betrag",
    sum: "Summe",
    amountTotal: "Gesamtbetrag",
    apply: "Anwenden",
    approved: "Genehmigt",
    ascending: "Aufsteigend",
    addContact: "Kontakt hinzufügen",
    addContent: "Inhalt hinzufügen",
    addSignature: "Unterschrift hinzufügen",
    avatar: "Avatar",
    back: "Zurück",
    bban: "BBAN",
    bicSwift: "BIC/SWIFT",
    bimester: "Bimester",
    calculatedValuesAreReferential: "Berechnete Werte sind referenziell",
    cancel: "Abbrechen",
    canceled: "Abgebrochen",
    city: "Stadt",
    comment: "Kommentar",
    completed: "Abgeschlossen",
    companyContact: "Unternehmenskontakt",
    content: "Inhalt",
    registerNumber: "Registernummer",
    concerning: "Betreffend",
    contactInformation: "Kontaktinformationen",
    continue: "Fortfahren",
    country: "Land",
    create: "Erstellen",
    createdDate: "Erstellungsdatum",
    currency: "Währung",
    customer: "Kunde",
    date: "Datum",
    day: "Tag",
    days: "Tage",
    default: "Standard",
    delete: "Löschen",
    descending: "Absteigend",
    description: "Beschreibung",
    detail: "Detail",
    details: "Details",
    discard: "Verwerfen",
    doNotGroup: "Nicht gruppieren",
    edit: "Bearbeiten",
    email: "E-Mail",
    end: "Ende",
    endDate: "Enddatum",
    excel: "Excel",
    export: "Exportieren",
    filter: "Filter",
    filterOptions: "Filteroptionen",
    firstName: "Vorname",
    group: "Gruppe",
    halfYear: "Halbjahr",
    iban: "IBAN",
    identity: "Identität",
    inProgress: "In Bearbeitung",
    justNow: "Gerade eben",
    lastDay: "Letzter Tag",
    lastName: "Nachname",
    legalInformation: "Rechtliche Informationen",
    list: "Liste",
    location: "Standort",
    menu: "Menü",
    message: "Nachricht",
    messages: "Nachrichten",
    archived: "Archiviert",
    read: "Gelesen",
    unread: "Ungelesen",
    archive: "Archiv",
    noNumber: "Keine Nummer",
    noMatchingRecordsFound: "Keine passenden Einträge gefunden",
    month: "Monat",
    months: "Monate",
    number: "Nummer",
    sortAlphabetically: "Alphabetisch sortieren",
    pages: "Seiten",
    pdf: "PDF",
    pending: "Ausstehend",
    person: "Person",
    phone: "Telefon",
    phoneNumber: "Telefonnummer",
    priceGross: "Bruttopreis",
    priceNet: "Nettopreis",
    priceTotal: "Gesamtpreis",
    product: "Produkt",
    products: "Produkte",
    qrIban: "QR-IBAN",
    quantity: "Menge",
    stockLimitReached: "Lagerbestand erreicht",
    lowStockWarning: "Niedriger Lagerbestand Warnung",
    accepted: "Akzeptiert",
    declined: "Abgelehnt",
    rejected: "Abgelehnt",
    sent: "Gesendet",
    remove: "Entfernen",
    removeReference: "Referenz entfernen",
    removeContent: "Inhalt entfernen",
    removeSignature: "Unterschrift entfernen",
    removeRequirement: "Block entfernen",
    removeVoucher: "Beleg entfernen",
    requirement: "Block",
    requirements: "Blöcke",
    reset: "Zurücksetzen",
    saveChanges: "Änderungen speichern",
    searchResults: "Suchergebnisse",
    selectExportFormat: "Exportformat auswählen",
    send: "Senden",
    service: "Dienstleistung",
    services: "Dienstleistungen",
    appService: "Anwendungsdienst",
    appServices: "Anwendungsdienste",
    signature: "Unterschrift",
    signatures: "Unterschriften",
    start: "Start",
    startDate: "Startdatum",
    status: "Status",
    street: "Straße",
    subTotal: "Zwischensumme",
    support: "Support",
    symbol: "Symbol",
    tax: "Steuer",
    taxSale: "Verkaufssteuer",
    taxPurchase: "Einkaufssteuer",
    taxRate: "Steuersatz",
    taxTotal: "Gesamtsteuer",
    trimester: "Trimester",
    total: "Gesamt",
    totalAmount: "Gesamtbetrag",
    top: "Oben",
    type: "Typ",
    timeInterval: "Zeitintervall",
    interval: "Intervall",
    unitMeasure: "Maßeinheit",
    unitPrice: "Stückpreis",
    update: "Aktualisieren",
    validity: "Gültigkeit",
    value: "Wert",
    vatNumber: "USt/IDE-Nummer",
    contactCode: "Kontaktcode",
    webSite: "Site Internet",
    week: "Woche",
    weeks: "Wochen",
    view: "Ansehen",
    yes: "Ja",
    zipCode: "Postleitzahl",
    gross: "Brutto",
    net: "Netto",
    rebate: "Rabatt",
    rebateTotal: "Gesamtrabatt",
    selectOptionAddAmountPercentageDesired: "Option auswählen und gewünschten Betrag oder Prozentsatz hinzufügen",
    changeImage: "Bild ändern",
    changeLogo: "Logo ändern",
    exportError: "Exportfehler",
    failedToLoadTheScript: "Skript konnte nicht geladen werden",
    identificationNumberForACompany: "Identifikationsnummer eines Unternehmens für europäische Operationen",
    internationalBankAccountNumberIban: "Internationale Bankkontonummer (IBAN)",
    listOfCompaniesIHaveAccess: "Liste der Unternehmen, auf die ich Zugriff habe",
    noRecordsFound: "Keine Einträge gefunden",
    noResultsFound: "Keine Ergebnisse gefunden",
    companyNotSubjectToVat: "Keine MWST-Abrechnungen",
    companyNotSubjectToVatDescription: "Dieses Unternehmen ist nicht mehrwertsteuerpflichtig. Es sind keine MWST-Abrechnungsperioden verfügbar.",
    removeImage: "Bild entfernen",
    selectTheTypeOfContact: "Wählen Sie die Art des Kontakts, den Sie erstellen möchten",
    specifyTheUniqueUUID: "Geben Sie die eindeutige UUID eines Benutzers oder Unternehmens an",
    theDefaultBankAccountIsTheCompanys: "Das Standard-Treasury-Konto gehört dem Unternehmen",
    theDefaultCurrencyIsTheCompanys: "Die Standardwährung gehört dem Unternehmen",
    theDefaultShapeOrVersionOfAQrInvoiceToDownloadIsTheClients:
      "Die Standardform oder Version einer herunterzuladenden QR-Rechnung gehört dem Kunden",
    theDefaultLanguageToDownloadIsTheClients: "Die Standardsprache für den Download gehört dem Kunden",
    youMustAcceptTheTermsAndConditions: "Sie müssen die Allgemeinen Geschäftsbedingungen akzeptieren",
    acceptingInvitationToAccessCompany: "Einladung zur Unternehmenszugang akzeptieren",
    verificationYourAccount: "Verifizierung Ihres Kontos",
    addCompany: "Unternehmen hinzufügen",
    allInLicense: "All-in-Lizenz",
    buyNow: "Jetzt kaufen",
    comingSoon: "Demnächst verfügbar",
    licenseTerms: "Lizenzbedingungen",
    pageNotFound: "Seite nicht gefunden",
    viewInvitations: "Einladungen anzeigen",
    purchase: "Kaufen",
    reload: "Neu laden",
    systemError: "Systemfehler",
    dashboard: "Dashboard",
    abbreviation: "Abkürzung",
    amountPurchases: "Einkaufsbetrag",
    amountSales: "Verkaufsbetrag",
    best: "Beste",
    companyInsight: "Unternehmensübersicht",
    comparativeInterval: "Vergleichsintervall",
    comparisonIncomeAndExpenses: "Vergleich von Einnahmen & Ausgaben",
    customerPayments: "Kundenzahlungen",
    customRange: "Benutzerdefinierter Zeitraum",
    debtPercent: "Schulden (%)",
    distributionOfQuotes: "Verteilung der Angebote nach Status",
    distributionOfOrders: "Verteilung der Bestellungen nach Status",
    expirationDate: "Ablaufdatum",
    creationDate: "Erstellungsdatum",
    invoicesStillToBePaid: "Rechnungen, die noch zu zahlen sind",
    invoicesStillToBePaidByTheCustomer: "Rechnungen, die vom Kunden noch zu zahlen sind",
    invoicesWithMoreDebt: "Rechnungen mit höherer Verschuldung",
    ordersByState: "Bestellungen nach Status",
    ordersToBilled: "Zu fakturierende Bestellungen",
    paidPercent: "Bezahlt (%)",
    percentage: "Prozentsatz",
    quotesByState: "Angebote nach Status",
    quotesAccepted: "Akzeptierte Angebote",
    quotesApproved: "Genehmigte Angebote",
    quotesToExpire: "Ablaufende Angebote",
    retailAnalysisSample: "Beispiel Einzelhandelsanalyse",
    representationOfSalesAndPurchases: "Darstellung von Verkäufen und Einkäufen pro Monat über ein Jahr",
    salesVsPurchases: "Verkäufe vs Einkäufe",
    thisBimester: "Dieses Bimester",
    thisTrimester: "Dieses Trimester",
    thisHalfYear: "Dieses Halbjahr",
    thisMonth: "Dieser Monat",
    thisWeek: "Diese Woche",
    thisYear: "Dieses Jahr",
    today: "Heute",
    turnout: "Rechnungsbetrag",
    viewAll: "Alle anzeigen",
    worst: "Schlechteste",
    yesterday: "Gestern",
    fixedAmount: "Fester Betrag",
    discount: "Rabatt",
    account: "Konto",
    changeEmail: "E-Mail ändern",
    changePassword: "Passwort ändern",
    confirmNewPassword: "Neues Passwort bestätigen",
    currentPassword: "Aktuelles Passwort",
    emailAddress: "E-Mail-Adresse",
    enterNewEmailAddress: "Neue E-Mail-Adresse eingeben",
    fullName: "Vollständiger Name",
    newPassword: "Neues Passwort",
    pleaseCheckYourEmailInbox: "Bitte überprüfen Sie Ihren E-Mail-Posteingang",
    profileCompleation: "Profilvollständigkeit",
    profileDetails: "Profildetails",
    signInMethod: "Anmeldemethode",
    updateEmail: "E-Mail aktualisieren",
    updatePassword: "Passwort aktualisieren",
    updateUser: "Benutzer aktualisieren",
    validateAccount: "Konto validieren",
    viewUser: "Benutzer anzeigen",
    user: "Benutzer",
    users: "Benutzer",
    confirmPassword: "Passwort bestätigen",
    createAnAccount: "Konto erstellen",
    enterYourEmailToResetYourPassword: "Geben Sie Ihre E-Mail ein, um Ihr Passwort zurückzusetzen",
    goToLoginPage: "Zur Anmeldeseite gehen",
    goToPreviousPage: "Zur vorherigen Seite gehen",
    language: "Sprache",
    languages: "Sprachen",
    myProfile: "Mein Profil",
    notVerified: "Nicht verifiziert",
    password: "Passwort",
    resetPassword: "Passwort zurücksetzen",
    signInHere: "Hier anmelden",
    signOut: "Abmelden",
    submit: "Absenden",
    userProfile: "Benutzerprofil",
    use8OrMoreCharacters: "Verwenden Sie 8 oder mehr Zeichen mit einer Kombination aus Groß- und Kleinbuchstaben, Zahlen und Symbolen",
    verified: "Verifiziert",
    welcome: "Willkommen",
    company: "Unternehmen",
    companies: "Unternehmen",
    current: "Aktuell",
    addDeadlinePaymentParameter: "Zahlungsfrist-Parameter hinzufügen",
    addFeatureParameter: "Feature-Parameter hinzufügen",
    addImage: "Bild hinzufügen",
    addTax: "Steuer hinzufügen",
    addDeadline: "Frist hinzufügen",
    addFeature: "Funktion hinzufügen",
    addTaxRateParameter: "Steuersatz-Parameter hinzufügen",
    addUnit: "Einheit hinzufügen",
    addUnitMeasureParameter: "Maßeinheit-Parameter hinzufügen",
    advanceSettings: "Erweiterte Einstellungen",
    aNewCompanyWillBeCreated: "Ein neues Unternehmen wird basierend auf den eingegebenen Daten erstellt",
    browseUsers: "Benutzer durchsuchen",
    companyAddress: "Unternehmensadresse",
    companyAdvanceSettings: "Erweiterte Unternehmenseinstellungen",
    companyDownloadSettings: "Unternehmens-Download-Einstellungen",
    companyAccountingSettings: "Einrichtung der Unternehmensbuchhaltung",
    companyGeneralSettings: "Konfigurieren allgemeiner Unternehmensparameter",
    companyInformationSettingGeneral: "Einstellung der allgemeinen Unternehmensinformationen",
    companyIdentity: "Unternehmensidentität",
    companyLogo: "Unternehmenslogo",
    companyName: "Unternehmensname",
    legalForm: "Rechtsform",
    legalFormSarl: "GmbH (Sàrl)",
    legalFormSa: "AG (SA)",
    legalFormRi: "Einzelunternehmen",
    legalFormSnc: "Kollektivgesellschaft (KlG)",
    legalFormCooperative: "Genossenschaft",
    legalFormAssociation: "Verein",
    legalFormFondation: "Stiftung",
    legalFormAutre: "Andere",
    createCompany: "Unternehmen erstellen",
    createAndSave: "Erstellen & Speichern",
    newCompany: "Neues Unternehmen",
    designOfDocumentToDownloadQuotesAndInvoices: "Dokumentgestaltung zum Herunterladen von Angeboten, Bestellungen und Rechnungen",
    downloadSettings: "Download-Einstellungen",
    dueDates: "Fälligkeitstermine für Rechnungszahlungen",
    editCompany: "Unternehmen bearbeiten",
    free: "Kostenlos",
    generalSettings: "Allgemeine Einstellungen",
    helpPage: "Hilfeseite",
    image: "Bild",
    inviteAccessCompany: "Zum Zugriff auf das Unternehmen einladen",
    legal: "Rechtlich",
    listUsers: "Benutzer auflisten",
    logo: "Logo",
    name: "Name",
    new: "Neu",
    noResultFound: "Kein Ergebnis gefunden",
    overview: "Übersicht",
    accountingSettings: "Buchhaltungseinstellungen",
    pleaseTryAgainWithADifferentQuery: "Bitte versuchen Sie es mit einer anderen Abfrage erneut",
    predefinedTaxesFees: "Vordefinierte Steuern/Gebühren",
    predefinedValues: "Vordefinierte Werte",
    freeInput: "Freie Eingabe",
    inputMethod: "Eingabemethode",
    private: "Privat",
    removeLogo: "Logo entfernen",
    selectModel: "Modell auswählen",
    selectAndSaveDesiredLayoutToDownload: "Gewünschtes Layout auswählen und speichern, um Angebot, Bestellung und Rechnung herunterzuladen",
    selectAndSaveOneToFourDesiredColors:
      "Wählen Sie ein bis vier gewünschte Farben aus und speichern Sie diese für das Design von Angebot, Bestellung und Rechnung",
    sendInvitation: "Einladung senden",
    settings: "Einstellungen",
    taxValue: "Steuerwert",
    templateColors: "Vorlagenfarben",
    templateModel: "Vorlagenmodell",
    unitsOfMeasure: "Maßeinheiten für eine Dienstleistung oder ein Produkt",
    characteristicsForServiceProduct: "Merkmale einer Dienstleistung oder eines Produkts",
    uuidCode: "UUID-Code",
    uuidCompany: "UUID-Unternehmen",
    uuidOrName: "UUID/Name",
    usersWhoAreSubscribed: "Benutzer, die abonniert sind und Zugriff auf das Unternehmen haben",
    viewCompany: "Unternehmen anzeigen",
    viewMoreUsers: "Weitere Benutzer anzeigen",
    treasury: "Schatzamt",
    treasuryAccount: "Schatzamtkonto",
    treasuryCashAccount: "Schatzamtkonto Bargeld",
    treasuryCardAccount: "Schatzamtkonto Karte",
    noCashTreasuryAccounts: "Keine Bargeld-Schatzamtkonten verfügbar",
    noCardTreasuryAccounts: "Keine Karten-Schatzamtkonten verfügbar",
    conceptAccount: "Konzeptkonto",
    treasuryAccounts: "Schatzamtkonten",
    codeOfBelongingToABankingOrganization: "Code der Zugehörigkeit zu einer Bankorganisation",
    createNewTreasuryAccount: "Neues Schatzamtkonto erstellen",
    createTreasuryAccount: "Schatzamtkonto erstellen",
    listTreasuryAccounts: "Schatzamtkonten auflisten",
    listBookingJournals: "Buchungsjournale auflisten",
    listAccountingAccounts: "Buchhaltungskonten auflisten",
    viewBookingJournal: "Buchungsjournal anzeigen",
    membership: "Mitgliedschaft",
    nameOfAccount: "Name des Kontos",
    contactUs: "Kontaktieren Sie uns",
    typeOfTreasuryAccount: "Art des Schatzamtkontos",
    updateTreasuryAccountData: "Schatzamtkonto-Daten aktualisieren",
    viewTreasuryAccountsList: "Liste der Schatzamtkonten anzeigen",
    notification: "Benachrichtigung",
    notifications: "Benachrichtigungen",
    accept: "Akzeptieren",
    accessToCompany: "Zugriff auf Unternehmen",
    activities: "Aktivitäten",
    answers: "Antworten",
    close: "Schließen",
    companyInvitations: "Unternehmenseinladungen",
    hasReceivedANotification: "Hat eine Benachrichtigung erhalten",
    hasReceivedAQuote: "Hat ein Angebot erhalten",
    hasReceivedAnInvitation: "Hat eine Einladung erhalten",
    hasReceivedAnOrder: "Hat eine Bestellung erhalten",
    newNotification: "Neue Benachrichtigung",
    noNotifications: "Keine Benachrichtigungen",
    noInvitations: "Es gibt keine Einladungen",
    other: "Andere",
    quoteEvaluation: "Angebotsbewertung",
    quoteNotification: "Angebotsbenachrichtigung",
    approve: "Genehmigen",
    reject: "Ablehnen",
    contact: "Kontakt",
    contacts: "Kontakte",
    basicBankAccountNumber: "Grundlegende Schatzamtkontonummer",
    bankIdentifierCode: "Bank-Identifikationscode / Society for Worldwide Interbank Financial Telecommunication",
    listContacts: "Kontaktliste",
    contactUUID: "Kontakt-UUID",
    contactIdentity: "Kontaktidentität",
    contactIsNotAnAppUser: "Der Kontakt ist kein App-Benutzer",
    contactType: "Kontaktart",
    contactUuidAndType: "Kontakt-UUID und Art",
    countryContact: "Länderkontakt",
    createContact: "Kontakt erstellen",
    createNewContact: "Neuen Kontakt erstellen",
    createContactCompanyStructure: "Kontaktstruktur für Unternehmen erstellen",
    createContactPersonStructure: "Kontaktstruktur für Person erstellen",
    deleteContact: "Kontakt löschen",
    deleteSelected: "Ausgewählte löschen",
    definingTheIdentityOfContact: "Definieren der Identität des Kontakts",
    definingTheInformationOfContact: "Definieren der Informationen des Kontakts",
    definingTheLegalInformationOfContact: "Definieren der rechtlichen Informationen des Kontakts",
    definingTheSettingsToDownloadQuotesAndInvoices: "Definieren der Einstellungen zum Herunterladen von Angeboten und Rechnungen",
    dragOrClickOnTheBoxToAddTheCompanyLogo: "Ziehen Sie das Logo in das Feld oder klicken Sie darauf, um das Unternehmenslogo hinzuzufügen",
    editContact: "Kontakt bearbeiten",
    enterThePostalCodeOfTheCity: "Geben Sie die Postleitzahl der Stadt ein",
    exportContacts: "Kontakte exportieren",
    exportEntryContacts: "Buchungsexport",
    extendChanges: "Änderungen erweitern",
    fileDownloadSettings: "Datei-Download-Einstellungen",
    financialEntity: "Finanzinstitut",
    identityOfContact: "Identität des Kontakts",
    ifAddressDoesNotHaveANumber: "Wenn die Adresse keine Nummer hat, geben Sie 'nn' oder 'NN' ein",
    whenNumberIsNotEntered: "Wenn die Nummer nicht eingegeben wird, wird sie durch „NN“ dargestellt",
    ifNecessaryEnterSomethingReferentialRegardingAddress: "Falls erforderlich, geben Sie etwas Referenzielles zur Adresse ein",
    informationOfContact: "Informationen des Kontakts",
    internationalBankAccountNumber: "Internationale Bankkontonummer",
    languageToDownload: "Sprache zum Herunterladen von Angebot, Bestellung oder Rechnung",
    legalInformationOfContact: "Rechtliche Informationen des Kontakts",
    qrType: "QR-Rechnungstyp",
    shapesOrVersionsOfQR: "Formen oder Versionen einer QR-Rechnung",
    basicCurrencyCompany: "Basiswährung des Unternehmens",
    selectCompanyAndSave: "Unternehmen auswählen und speichern",
    selectCompaniesToCreateContact: "Unternehmen auswählen, zu denen ein neuer Kontakt hinzugefügt wird",
    typeOfContact: "Kontaktart",
    updateContactData: "Kontaktdaten aktualisieren",
    uuidAndType: "UUID und Art",
    userUuid: "Benutzer-UUID",
    viewContact: "Kontakt anzeigen",
    addresses: "Adressen",
    addAddress: "Adresse hinzufügen",
    editAddress: "Adresse bearbeiten",
    deleteAddress: "Adresse löschen",
    addressLabel: "Adressbezeichnung",
    addressType: "Adresstyp",
    deliveryType: "Lieferung",
    billingType: "Rechnung",
    otherType: "Sonstige",
    defaultDeliveryAddress: "Standard-Lieferadresse",
    setAsDefault: "Als Standard festlegen",
    mainAddressBadge: "Haupt",
    noAddressesYet: "Noch keine Adressen hinzugefügt",
    quote: "Angebot",
    quotes: "Angebote",
    addQuote: "Angebot hinzufügen",
    approveQuote: "Angebot genehmigen",
    companyQuoteList: "Unternehmensangebotsliste",
    createQuote: "Angebot erstellen",
    newQuote: "Neues Angebot",
    dateOfDocument: "Dokumentdatum, dies kann später geändert werden",
    editQuote: "Angebot bearbeiten",
    enterADateOrSelectADefaultPaymentDeadline: "Geben Sie ein Datum ein oder wählen Sie eine Standardzahlungsfrist",
    expired: "Abgelaufen",
    exportQuotes: "Angebote exportieren",
    generateQuote: "Angebot erstellen",
    inTime: "Rechtzeitig",
    listQuotes: "Angebote auflisten",
    quoteDate: "Angebotsdatum",
    quoteGroups: "Angebotsgruppen",
    quoteNumber: "Angebotsnummer",
    quoteReference: "Angebotsreferenz",
    quoteStatus: "Angebotsstatus",
    quoteValidity: "Gültigkeit des Angebots",
    rejectQuote: "Angebot ablehnen",
    sendQuote: "Angebot senden",
    updateQuote: "Angebot aktualisieren",
    viewQuote: "Angebot anzeigen",
    purchases: "Einkäufe",
    sales: "Verkäufe",
    sale: "Verkauf",
    principal: "Hauptkonto",
    humanResources: "Personalwesen",
    closingJournal: "Abschlussjournal",
    manuallyCreated: "Manuell erstellt",
    expenses: "Ausgaben",
    addExpense: "Ausgabe hinzufügen",
    createExpense: "Ausgabe erstellen",
    editExpense: "Ausgabe bearbeiten",
    expenseDate: "Ausgabedatum",
    expenseGroups: "Ausgabengruppen",
    expenseNumber: "Ausgabenummer",
    expenseValidity: "Gültigkeit der Ausgabe",
    invalidateExpense: "Ausgabe ungültig machen",
    listExpenses: "Ausgaben auflisten",
    removeExpense: "Ausgabe entfernen",
    updateExpense: "Ausgabe aktualisieren",
    validateExpense: "Ausgabe validieren",
    viewExpense: "Ausgabe anzeigen",
    addProviderInvoice: "Lieferantenrechnung hinzufügen",
    createProviderInvoice: "Lieferantenrechnung erstellen",
    editProviderInvoice: "Lieferantenrechnung bearbeiten",
    invalidateProviderInvoice: "Lieferantenrechnung ungültig machen",
    listProviderInvoices: "Lieferantenrechnungen auflisten",
    myTreasuryAccount: "Mein Schatzamtkonto",
    provider: "Lieferant",
    providerBankAccount: "Bankkonto des Lieferanten",
    providerInvoiceDate: "Rechnungsdatum des Lieferanten",
    providerInvoiceGroups: "Lieferantenrechnungsgruppen",
    providerInvoiceStatus: "Lieferantenrechnungsstatus",
    providerInvoiceValidity: "Gültigkeit der Lieferantenrechnung",
    providerInvoices: "Lieferantenrechnungen",
    providerOrderNumber: "Lieferantenbestellnummer",
    updateProviderInvoice: "Lieferantenrechnung aktualisieren",
    validateProviderInvoice: "Lieferantenrechnung validieren",
    viewProviderInvoice: "Lieferantenrechnung anzeigen",
    addProviderOrder: "Lieferantenbestellung hinzufügen",
    approveProviderOrder: "Lieferantenbestellung genehmigen",
    cancelProviderOrder: "Lieferantenbestellung stornieren",
    createProviderOrder: "Lieferantenbestellung erstellen",
    editProviderOrder: "Lieferantenbestellung bearbeiten",
    generateProviderInvoice: "Lieferantenrechnung erstellen",
    generateProviderOrder: "Lieferantenbestellung erstellen",
    listProviderOrders: "Lieferantenbestellungen auflisten",
    providerOrderDate: "Lieferantenbestelldatum",
    providerOrders: "Lieferantenbestellungen",
    providerOrderGroups: "Lieferantenbestellgruppen",
    providerOrderReference: "Lieferantenbestellreferenz",
    providerInvoiceReference: "Lieferantenrechnungsreferenz",
    expenseReference: "Ausgabenreferenz",
    providerOrderStatus: "Lieferantenbestellstatus",
    updateProviderOrder: "Lieferantenbestellung aktualisieren",
    viewProviderOrder: "Lieferantenbestellung anzeigen",
    providerQuote: "Lieferantenangebot",
    providerQuotes: "Lieferantenangebote",
    listProviderQuotes: "Liste der Lieferantenangebote",
    viewProviderQuote: "Lieferantenangebot anzeigen",
    sourceQuoteNumber: "Quellangebot-Ref.",
    sourceCompany: "Ausstellerunternehmen",
    acceptQuote: "Angebot annehmen",
    declineQuote: "Angebot ablehnen",
    internalNotes: "Interne Notizen",
    saveNotes: "Notizen speichern",
    providerQuoteAccepted: "Angebot angenommen, Lieferantenbestellung erstellt",
    providerQuoteDeclined: "Angebot abgelehnt",
    confirmAcceptQuote: "Dieses Angebot annehmen? Eine Lieferantenbestellung wird automatisch erstellt.",
    confirmDeclineQuote: "Dieses Angebot ablehnen?",
    declineReasonLabel: "Ablehnungsgrund",
    declineReasonPlaceholder: "Bitte erklären Sie, warum Sie dieses Angebot ablehnen...",
    declineInvoiceReasonPlaceholder: "Bitte erklären Sie, warum Sie diese Rechnung ablehnen...",
    declineReasonRequired: "Ein Grund ist erforderlich, um abzulehnen.",
    recipientDecision: "Entscheidung des Empfängers",
    decisionAccepted: "Vom Empfänger akzeptiert",
    decisionDeclined: "Vom Empfänger abgelehnt",
    decisionDate: "Datum der Entscheidung",
    declineReason: "Ablehnungsgrund",
    acceptanceStatus: "Annahmestatus",
    acceptancePending: "Annahme ausstehend",
    acceptanceNotRequired: "Nicht erforderlich",
    acceptInvoice: "Rechnung annehmen",
    declineInvoice: "Rechnung ablehnen",
    providerInvoiceAccepted: "Rechnung angenommen",
    providerInvoiceDeclined: "Rechnung abgelehnt",
    confirmAcceptInvoice: "Diese Rechnung annehmen?",
    confirmDeclineInvoice: "Diese Rechnung ablehnen?",
    seeProviderOrder: "Lieferantenbestellung anzeigen",
    addVouchers: "Beleg(e) hinzufügen",
    download: "Herunterladen",
    file: "Datei",
    lastModified: "Zuletzt geändert",
    size: "Größe",
    vouchers: "Belege",
    addFiles: "Dateien hinzufügen",
    attachFiles: "Dateien anhängen",
    removeAll: "Alle entfernen",
    uploadFiles: "Dateien hochladen",
    orders: "Bestellungen",
    order: "Bestellung",
    orderEvaluation: "Bestellbewertung",
    orderGroups: "Bestellgruppen",
    orderNotification: "Bestellbenachrichtigung",
    orderReference: "Bestellreferenz",
    orderStatus: "Bestellstatus",
    addOrder: "Bestellung hinzufügen",
    approveOrder: "Bestellung genehmigen",
    rejectOrder: "Bestellung ablehnen",
    cancelOrder: "Bestellung stornieren",
    companyListOfOrders: "Unternehmensliste der Bestellungen",
    companyListOfInvoices: "Unternehmensliste der Rechnungen",
    companyListOfQuotes: "Unternehmensliste der Angebote",
    companyListOfProviderInvoices: "Lieferantenrechnungen des Unternehmens",
    companyListOfProviderOrders: "Lieferantenbestellungen des Unternehmens",
    companyListOfProviderQuotes: "Lieferantenangebote des Unternehmens",
    companyListOfExpenses: "Ausgabenliste des Unternehmens",
    companyListOfExpenseReports: "Spesenabrechnungen des Unternehmens",
    createOrder: "Bestellung erstellen",
    delivery: "Lieferung",
    deliveyAddress: "Lieferadresse",
    deliveryNote: "Lieferschein",
    deliveryNotes: "Lieferscheine",
    createDeliveryNote: "Lieferschein erstellen",
    noDeliveryNotesYet: "Noch keine Lieferscheine",
    delivered: "Geliefert",
    notDelivered: "Nicht geliefert",
    deliveryDate: "Lieferdatum",
    deliverAll: "Alles liefern",
    quantityToDeliver: "Liefermenge",
    quantityOrdered: "Bestellmenge",
    quantityDelivered: "Gelieferte Menge",
    quantityRemaining: "Restmenge",
    alreadyFullyDelivered: "Bereits vollständig geliefert",
    quantityReceived: "Empfangene Menge",
    quantityToEnter: "Einzugebende Menge",
    allItemsReceived: "Alle Artikel wurden empfangen",
    selectAtLeastOneQuantity: "Bitte wählen Sie mindestens eine einzugebende Menge aus",
    sendByEmail: "Per E-Mail senden",
    sendToCustomer: "An den Kunden senden",
    personalizedMessage: "Personalisierte Nachricht",
    deliveryAddressSelection: "Lieferadresse auswählen",
    mainAddress: "Hauptadresse",
    manageAddresses: "Adressen verwalten",
    storageCenterSelection: "Lagerzentrum auswählen",
    autoStockOut: "Automatischer Warenausgang",
    quantityInStock: "Menge auf Lager",
    stockAvailability: "Lagerverfügbarkeit",
    stockWarnings: "Bestandswarnungen",
    deliveryProgress: "Lieferfortschritt",
    deliveryComplete: "Lieferung abgeschlossen",
    deliveryPartial: "Teillieferung",
    notDeliveredYet: "Noch nicht geliefert",
    deliveryAddressLabel: "Lieferadresse",
    sentAt: "Gesendet am",
    sentMethod: "Versandmethode",
    backToOrder: "Zurück zur Bestellung",
    linesDelivered: "Gelieferte Positionen",
    createInvoiceFromSelection: "Rechnung aus Auswahl erstellen",
    ordersWillBeInvoicedTogether: "Bestellung(en) werden zusammen fakturiert",
    ordersSelected: "Bestellung(en) ausgewählt",
    editOrder: "Bestellung bearbeiten",
    exportOrder: "Bestellung exportieren",
    exportOrders: "Bestellungen exportieren",
    generateInvoice: "Rechnung erstellen",
    generateOrder: "Bestellung erstellen",
    listOrders: "Bestellungen auflisten",
    orderDate: "Bestelldatum",
    orderFile: "Bestelldatei",
    orderNumber: "Bestellnummer",
    selectExportType: "Exporttyp auswählen",
    sendOrder: "Bestellung senden",
    thisOptionIsUniqueAndNewInvoice: "Diese Option ist einzigartig und es kann keine neue Rechnung aus dieser Bestellung erstellt werden",
    updateOrder: "Bestellung aktualisieren",
    viewOrder: "Bestellung anzeigen",
    invoice: "Rechnung",
    invoices: "Rechnungen",
    addInvoice: "Rechnung hinzufügen",
    amountDebt: "Schuldenbetrag",
    amountPaid: "Bezahlter Betrag",
    companyInvoiceList: "Unternehmensrechnungsübersicht",
    createInvoice: "Rechnung erstellen",
    editInvoice: "Rechnung bearbeiten",
    exportInvoices: "Rechnungen exportieren",
    exportProviderInvoices: "Lieferantenrechnungen exportieren",
    exportProviderOrders: "Lieferantenbestellungen exportieren",
    exportProviderQuotes: "Lieferantenangebote exportieren",
    exportExpenses: "Ausgaben exportieren",
    exportExpenseReports: "Spesenabrechnungen exportieren",
    debt: "Schulden",
    fullyPaid: "Vollständig bezahlt",
    invalidInvoices: "Ungültige Rechnungen",
    invalidateInvoice: "Rechnung ungültig machen",
    invalidateProviderOrder: "Ungültige Anordnung des Anbieters",
    validateProviderOrder: "Lieferantenbestellung prüfen",
    invoiceGroups: "Rechnungsgruppen",
    invoiceDate: "Rechnungsdatum",
    invoiceNumber: "Rechnungsnummer",
    invoiceStatus: "Rechnungsstatus",
    invoiceValidity: "Rechnungsgültigkeit",
    listInvoices: "Rechnungen auflisten",
    notPayed: "Nicht bezahlt",
    partiallyPaid: "Teilweise bezahlt",
    payed: "Bezahlt",
    thisInvoiceHasNoPayments: "Diese Rechnung hat keine Zahlungen",
    updateInvoice: "Rechnung aktualisieren",
    validated: "Validiert",
    validateInvoice: "Rechnung validieren",
    viewInvoice: "Rechnung anzeigen",
    youWillBeAbleToUndoThisAction: "Sie können diese Aktion rückgängig machen",
    payment: "Zahlung",
    payments: "Zahlungen",
    amountToPay: "Zu zahlender Betrag",
    createNewPayment: "Neue Zahlung erstellen",
    deleteSomePayment: "Einige Zahlungen löschen",
    doNotDeletePayments: "Keine Zahlungen löschen",
    makePayment: "Zahlung durchführen",
    method: "Methode",
    paymentDate: "Zahlungsdatum",
    paymentMethod: "Zahlungsmethode",
    save: "Speichern",
    sourceOfIncome: "Einnahmequelle",
    accountingAccountProductService: "Buchhaltungskonto für das Produkt oder die Dienstleistung",
    sourceTheAmount: "Quelle, wo der Betrag aus der Transaktion eingezahlt oder abgehoben wird",
    sourceTheAmountEntered: "Quelle, in die der Betrag der Transaktion eingetragen wird",
    sourceTheAmountWithdrawn: "Quelle, von der der Transaktionsbetrag abgehoben wird",
    cash: "Bargeld",
    card: "Karte",
    payPal: "PayPal",
    transfer: "Überweisung",
    mobile: "Mobil",
    thisOptionIncludeTaxPrice: "Diese Option enthält die Steuer im angegebenen Preis",
    thisOptionNotIncludeTaxPrice: "Diese Option enthält die Steuer nicht im angegebenen Preis",
    addOrRemoveContactCompanies: "Kontaktunternehmen hinzufügen oder entfernen",
    notifyMe: "Benachrichtigen",
    background: "Hintergrund",
    inventory: "Inventar",
    viewProduct: "Produkt anzeigen",
    storageCenter: "Lagerzentrum",
    listStorageCenter: "Liste der Lagerzentren",
    viewStorageCenter: "Ansicht des Lagerzentrums",
    afterSalesService: "Kundendienst",
    bookingJournals: "Buchungsjournale",
    appLanguage: "App-Sprache",
    theUuidCanBeUsedToCreateNnewContact: "Die UUID kann verwendet werden, um einen neuen Kontakt zu erstellen",
    settingInformation: "Einstellungsinformationen",
    addOrRemoveCompanies: "Unternehmen hinzufügen/entfernen",
    notGrouped: "Nicht gruppiert",
    notFiltered: "Nicht gefiltert",
    orderValidity: "Bestellungsgültigkeit",
    expiration: "Ablauf",
    quoteExpiration: "Angebotsablauf",
    orderExpiration: "Bestellablauf",
    invoiceExpiration: "Rechnungsablauf",
    discountTotal: "Gesamtrabatt",
    addService: "Dienstleistung hinzufügen",
    addProduct: "Produkt hinzufügen",
    noRecords: "Keine Einträge",
    quantityMinimumForRebate: "Mindestmenge für Rabatt",
    nonExistentRebateNegativePrice: "Nicht vorhandener Rabatt für negativen Preis",
    thisOptionRebateIsFixedAmount: "Diese Option zeigt an, dass der Rabatt ein fester Betrag ist",
    thisOptionRebateIsPercentage: "Diese Option zeigt an, dass der Rabatt ein Prozentsatz ist",
    thisOptionRebateIsNone: "Diese Option zeigt an, dass kein Rabatt vorhanden ist",
    totalAfterRebates: "Gesamt nach Rabatten",
    calculator: "Rechner",
    enterRebate: "Rabatt eingeben",
    reference: "Referenz",
    newOrder: "Neue Bestellung",
    invoiceReference: "Rechnungsreferenz",
    newInvoice: "Neue Rechnung",
    providerOrderValidity: "Gültigkeit der Lieferantenbestellung",
    expenseStatus: "Ausgabenstatus",
    newProviderOrder: "Neue Lieferantenbestellung",
    newProviderInvoice: "Neue Lieferantenrechnung",
    newExpense: "Neue Ausgabe",
    viewVoucher: "Beleg anzeigen",
    informationAdditional: "Zusätzliche Informationen",
    no: "Nein",
    bank: "Bank",
    fullNameBankAccountHolder: "Vollständiger Name des Kontoinhabers",
    bankAccountHolder: "Kontoinhaber",
    isNecessaryToHaveReferenceToActivateOption: "Es ist notwendig, eine Referenz zu haben, um diese Option zu aktivieren",
    isNecessaryToHaveAtLeastTwoTreasuryAccountsToActivateOption:
      "Es ist notwendig, mindestens zwei Schatzamtkonten zu haben, um diese Option zu aktivieren",
    none: "Keine",
    undefined: "Nicht definiert",
    colorCombinationForDesignOfDocumentToDownload: "Farbkombination für das Design des herunterzuladenden Dokuments",
    all: "Alle",
    lettersTitlesSubtitles: "Buchstaben, Titel, Untertitel",
    firstBar: "Erste Leiste",
    secondBar: "Zweite Leiste",
    barLetters: "Leistenbuchstaben",
    qrIbanAndQrReference: "QR-IBAN und QR-Referenz",
    ibanAndStructuredCreditorReference: "IBAN und strukturierte Gläubigerreferenz (SCOR)",
    ibanWithoutReference: "IBAN ohne Referenz",
    cashAccount: "Bargeldkonto",
    postalAccount: "Postkonto",
    bankAccount: "Bankkonto",
    currentAccount: "Kontokorrent Gesellschafter",
    listProducts: "Produktliste",
    category: "Kategorie",
    categories: "Kategorien",
    listCategories: "Kategorien auflisten",
    tags: "Tags",
    variants: "Varianten",
    photography: "Fotografie",
    reminder: "Erinnerung",
    reminders: "Erinnerungen",
    paymentStatus: "Zahlungsstatus",
    year: "Jahr",
    createReminder: "Erinnerung erstellen",
    updateReminder: "Erinnerung aktualisieren",
    makeCopy: "Kopie erstellen",
    reminderTotal: "Gesamterinnerung",
    inDispute: "Im Streitfall",
    addCategory: "Kategorie hinzufügen",
    addStorageCenter: "Lagerzentrum hinzufügen",
    addBookingJournal: "Buchungsjournal hinzufügen",
    qtyAssets: "Anzahl Vermögenswerte",
    qtyServices: "Anzahl Dienstleistungen",
    qtyProducts: "Anzahl Produkte",
    viewCategory: "Kategorie anzeigen",
    editCategory: "Kategorie bearbeiten",
    deleteCategory: "Kategorie löschen",
    names: "Namen",
    listCategoryItems: "Kategorieelemente auflisten",
    editListing: "Eintrag bearbeiten",
    updateCategoryItemList: "Kategorieelementliste aktualisieren",
    updateCategory: "Kategorie aktualisieren",
    nameInOtherLanguages: "Name in anderen Sprachen",
    enterInLanguageWant: "Geben Sie in der gewünschten Sprache ein",
    enterNameOfRequestedLanguages: "Geben Sie den Namen der gewünschten Sprachen ein",
    enterDesiredValuePressEnterAdd: "Geben Sie den gewünschten Wert ein und drücken Sie die Eingabetaste, um ihn hinzuzufügen",
    enterOrModifyInLanguage: "Geben Sie ein oder ändern Sie in der gewünschten Sprache",
    general: "Allgemein",
    categoryName: "Kategoriename",
    categoryType: "Kategorieart",
    createCategory: "Kategorie erstellen",
    editProduct: "Produkt bearbeiten",
    deleteProduct: "Produkt löschen",
    productReferencePictures: "Produktreferenzbilder",
    code: "Code",
    sku: "SKU",
    codebar: "Barcode",
    color: "Farbe",
    unit: "Einheit",
    price: "Preis",
    priceSale: "Verkaufspreis",
    pricePurchase: "Kaufpreis",
    fixed: "Fest",
    productName: "Produktname",
    productDetails: "Produktdetails",
    advanced: "Erweitert",
    addVariant: "Variante hinzufügen",
    uniqueProductCodeAssignedByCompany: "Eindeutiger vom Unternehmen zugewiesener Produktcode",
    additionalCommentDescriptionProductVariant: "Zusätzlicher Kommentar oder Beschreibung für die Produktvariante",
    selectDiscountTypeAppliedToProduct: "Wählen Sie einen Rabatttyp für dieses Produkt",
    discountType: "Rabattart",
    selectDiscountTypeThatWillAppliedProduct: "Wählen Sie einen Rabatttyp, der auf dieses Produkt angewendet wird",
    noDiscount: "Kein Rabatt",
    setDiscountPercentage: "Rabattprozentsatz festlegen",
    fixedDiscountedAmount: "Fester Rabattbetrag",
    quantityMinimumDiscount: "Mindestmenge für Rabatt",
    createProduct: "Produkt erstellen",
    dropFilesHereOrClickUpload: "Dateien hier ablegen oder zum Hochladen klicken",
    dropFileHereOrClickUpload: "Datei hier ablegen oder zum Hochladen klicken",
    uploadUpToFiles: "Bis zu 10 Dateien hochladen",
    success: "Erfolg",
    addNewProductVariant: "Neue Produktvariante hinzufügen",
    editVariant: "Variante bearbeiten",
    editProductVariant: "Produktvariante bearbeiten",
    updateProduct: "Produkt aktualisieren",
    saveVariant: "Variante speichern",
    listServices: "Dienstleistungsliste",
    viewService: "Dienstleistung anzeigen",
    editService: "Dienstleistung bearbeiten",
    deleteService: "Dienstleistung löschen",
    serviceReferencePictures: "Referenzbilder der Dienstleistung",
    serviceName: "Dienstleistungsname",
    serviceDetails: "Dienstleistungsdetails",
    createService: "Dienstleistung erstellen",
    updateService: "Dienstleistung aktualisieren",
    uniqueServiceCodeAssignedByCompany: "Eindeutiger vom Unternehmen zugewiesener Dienstleistungscode",
    selectDiscountTypeAppliedToService: "Wählen Sie einen Rabatttyp für diese Dienstleistung",
    expenseAccount: "Aufwandskonto",
    vatAccount: "Umsatzsteuerkonto",
    accountProduct: "Produktkonto",
    accountingAccount: "Buchhaltungskonto",
    accountingAccounts: "Buchhaltungskonten",
    accountingAccountPurchases: "Buchhaltungskonto für Einkäufe",
    accountingAccountSales: "Buchhaltungskonto für Verkäufe",
    addAccountingAccount: "Buchhaltungskonto hinzufügen",
    rangeAllowedCodes: "Bereich erlaubter Codes",
    effective: "Effektive Abrechnung",
    tdfn: "Satz der Nettosteuerschuld (TDFN)",
    taf: "Pauschalsatz (TaF)",
    vatAccountingType: "Art der Mehrwertsteuerabrechnung",
    theVatRegimeCanOnlyChangedOnceAYear:
      "Das Umsatzsteuerregime kann nur einmal jährlich geändert werden, kurz vor Beginn eines neuen Geschäftsjahres",
    debit: "Soll",
    credit: "Haben",
    customerReceivable: "Forderungen gegenüber Kunden",
    providerReceivable: "Forderungen gegenüber Lieferanten",
    vatDue: "Fällige Umsatzsteuer",
    vatRecoverable: "Erstattungsfähige Umsatzsteuer",
    declarationMethod: "Erklärungsmethode",
    onInvoicing: "Nach Rechnungsstellung (bei Fakturierung)",
    onCashing: "Nach Zahlungseingang (bei Zahlungseingang)",
    valid: "Gültig",
    invalid: "Ungültig",
    colorIsInvalid: "Ungültige Farbe",
    theValueIsNotAValid: "Der Wert ist ungültig",
    theValueIsNotAValidUUIDOrNameUser: "Der Wert ist keine gültige UUID oder kein gültiger Benutzername",
    theValueIsAtLeast8Digits: "Der Wert hat mindestens 8 Stellen",
    theValueDoesNotMatch: "Der Wert stimmt nicht überein",
    theValueAlreadyExists: "Der Wert existiert bereits",
    limitFilesMaximum: "Maximale Grenze von 10 Dateien",
    required: "Erforderlich",
    theValueIsRequired: "Der Wert ist erforderlich",
    allValuesRequired: "Alle Werte sind erforderlich",
    colorIsRequired: "Farbe ist erforderlich",
    requirementsIsRequired: "Blöcke sind erforderlich",
    paymentsIsRequired: "Zahlungen sind erforderlich",
    contentsToRequirementIsRequired: "Blockinhalt ist erforderlich",
    transaction: "Transaktion",
    createNewPaymentForInvoice: "Neue Zahlung für Rechnung erstellen",
    createNewPaymentForProviderInvoice: "Neue Zahlung für Lieferantenrechnung erstellen",
    addTransaction: "Transaktion hinzufügen",
    accountingEntry: "Buchung",
    amountAvailable: "Verfügbarer Betrag",
    selectExistingTransaction: "Vorhandene Transaktion auswählen",
    totalAmountDebt: "Gesamtschuldenbetrag",
    presetCurrency: "Voreingestellte Währung",
    deposit: "Einzahlung",
    deposition: "Einzahlung",
    depositAmount: "Einzahlungsbetrag",
    pastTransactions: "Vergangene Transaktionen",
    noPastTransactions: "Keine vergangenen Transaktionen",
    selectTransaction: "Transaktion auswählen",
    providerInvoice: "Lieferantenrechnung",
    expense: "Ausgabe",
    enterNewTransaction: "Neue Transaktion eingeben",
    useExistingTransaction: "Bestehende Transaktion verwenden",
    transactionToRecordPayment: "Transaktion, um die Zahlung zu erfassen",
    amountMoneyEnteredInTransaction: "Betrag der in der Transaktion eingegebenen Gelder",
    amountMoneyWithdrawnInTransaction: "Betrag, der in der Transaktion abgehoben wurde",
    identifiedTransactions: "Identifizierte Transaktionen",
    unidentifiedTransactions: "Nicht identifizierte Transaktionen",
    totalDepositAmount: "Gesamteinzahlungsbetrag",
    makeCorrespondingPayment: "Entsprechende Zahlung leisten",
    balance: "Saldo",
    accountingEntries: "Buchungen",
    contactBalance: "Kontakt-Saldo",
    accountStatement: "Kontoauszug",
    accountStatements: "Kontoauszüge",
    invoiceIssuance: "Rechnungsausstellung",
    saleIssuance: "Verkaufsausgabe",
    providerInvoiceIssuance: "Lieferantenrechnungsausstellung",
    expenseIssuance: "Ausgabenerstellung",
    allocationInvoiceReminder: "Zuweisung für Rechnungserinnerung",
    transactionToPostFinance: "PostFinance-Kontotransaktion",
    transactionFormPostFinance: "PostFinance-Kontotransaktion",
    balancePrevious: "Vorheriger Saldo",
    includeOpeningBalance: "Eröffnungssaldo einbeziehen",
    balanceFavorContact: "Saldo zu Ihren Gunsten",
    balanceFavorCompany: "Saldo zu unseren Gunsten",
    addCredit: "Gutschrift hinzufügen",
    addDebit: "Lastschrift hinzufügen",
    createClientCredit: "Neue Habenbuchung",
    createClientDebit: "Neue Sollbuchung",
    unidentifiedTransactionToRegisterInContact: "Nicht identifizierte Transaktion, die im Kontakt registriert werden soll",
    draft: "Entwurf",
    revertToDraft: "Zurück zum Entwurf",
    beforeCreatingProviderInvoice: "Vor der Erstellung einer Lieferantenrechnung",
    beforeCreatingProviderOrder: "Vor der Erstellung einer Lieferantenbestellung",
    beforeCreatingExpense: "Vor der Erstellung einer Ausgabe",
    viewPdf: "PDF anzeigen",
    viewOriginalPdf: "Original-PDF anzeigen",
    documentPdf: "Dokument-PDF",
    viewReferencePdf: "Referenz-PDF anzeigen",
    referencePdf: "Referenz-PDF",
    invalidFileType: "Datei in anderem Format",
    fileInDifferentFormatImg: "Datei in anderem Format. Erlaubte Dateitypen: jpeg, jpg oder png",
    fileSizeNotAllowed: "Datei zu groß. Maximale Dateigröße: 1 MB",
    fileInDifferentFormatPdf: "Datei in einem anderen Format. Dateiformat: pdf",
    fileIsTooBig: "Die Datei ist zu groß. Maximale Dateigröße: 10 MB",
    addDocument: "Dokument hinzufügen",
    validate: "Validieren",
    invalidate: "Ungültig machen",
    listing: "Auflistung",
    creation: "Erstellung",
    accounting: "Buchhaltung",
    generalLedger: "Hauptbuch",
    bookingJournal: "Buchungsjournal",
    label: "Bezeichnung",
    multipleWriting: "Mehrfache Buchung",
    simplifiedMultipleWriting: "Vereinfachte Mehrfachbuchung",
    availableAmount: "Verfügbarer Betrag",
    level: "Ebene",
    coefficient: "Koeffizient",
    leave: "Verlassen",
    title: "Titel",
    writingSimple: "Einfache Buchung",
    writingMultiple: "Mehrfache Buchung",
    writingSimplifiedMultiple: "Vereinfachte Mehrfachbuchung",
    taxIncluded: "Mit Mehrwertsteuer",
    taxExcluded: "Ohne Mehrwertsteuer",
    taxFee: "Steuerbetrag (MwSt)",
    vatOptions: "MwSt-Optionen",
    interest: "Zinsen",
    penalty: "Strafe",
    refund: "Rückerstattung",
    creditNote: "Gutschrift",
    customerInterest: "Kundenzinsen",
    customerPenalty: "Kundenstrafe",
    customerRefund: "Vom Kunden ausgegebene Rückerstattung",
    providerPayment: "An Lieferanten gezahlte Zahlung",
    providerCreditNote: "Ausgestellte Lieferantengutschrift",
    providerInterest: "Lieferantenzinsen",
    providerPenalty: "Lieferantenstrafe",
    providerRefund: "Vom Lieferanten ausgegebene Rückerstattung",
    customerPayment: "Vom Kunden erhaltene Zahlung",
    customerCreditNote: "Vom Kunden ausgestellte Gutschrift",
    transactionType: "Transaktionstyp",
    resend: "Erneut senden",
    information: "Information",
    generalInformation: "Allgemeine Informationen",
    vatCalculationPeriod: "Mehrwertsteuerberechnungszeitraum",
    dependsWhetherCompanySubjectTax: "Dies hängt davon ab, ob das Unternehmen steuerpflichtig ist",
    dependsCompanySpecialVatRegime: "Es hängt von der besonderen Mehrwertsteuerregelung des Unternehmens ab",
    dependsCompanyVatCalculationPeriod: "Es hängt vom Mehrwertsteuerberechnungszeitraum des Unternehmens ab",
    upcomingVatStatement: "Bevorstehende Mehrwertsteuererklärung",
    deadline: "Frist",
    quarter: "Quartal",
    semester: "Semester",
    chartAccounts: "Kontenplan",
    vatStatement: "Umsatzsteuererklärung",
    listVatStatements: "Mehrwertsteuererklärungen auflisten",
    manual: "Handbuch",
    vatSettingsMap: "MwSt.-Einstellungen-Karte",
    listPeriodsStatement: "Liste der Zeiträume für die Umsatzsteuererklärung",
    vatAmount: "MWST",
    vatAmountDue: "Mehrwertsteuerbetrag fällig",
    regime: "Regime",
    calculation: "Berechnung",
    tickets: "Tickets",
    pendingVatTickets: "Ausstehende MwSt-Tickets",
    orphansOnly: "Nur verwaiste",
    formLine: "Formularzeile",
    vatShort: "MwSt",
    side: "Seite",
    accrual: "Rückstellung",
    open: "Geöffnet",
    filed: "Eingereicht",
    closed: "Geschlossen",
    listPeriodStatement: "Liste der Berichtszeiträume",
    exportStatementPeriod: "Export des Berichtszeitraums",
    editAccountingSettings: "Buchhaltungseinstellungen bearbeiten",
    brand: "Marke",
    features: "Merkmale",
    createStorageCenter: "Lagerzentrum erstellen",
    updateStorageCenter: "Lagerzentrum aktualisieren",
    editStorageCenter: "Speicherzentrum bearbeiten",
    addInventory: "Zum Inventar hinzufügen",
    storagePurchase: "Lagerung zum Kauf",
    operations: "Betrieb",
    storageOperations: "Speichervorgänge",
    listOperationsStorageCenter: "Liste der Vorgänge eines Lagerzentrums",
    sourceLocation: "Quellort",
    destinationLocation: "Zielort",
    source: "Quelle",
    invalidated: "Ungültig",
    in: "Rein",
    out: "Raus",
    adjustment: "Einstellung",
    stockEntry: "Wareneingang",
    stockExit: "Warenausgang",
    stockTransfer: "Lagertransfer",
    sourceStorageCenter: "Ausgangslager",
    destinationStorageCenter: "Eingangslager",
    availableStock: "Verfügbarer Bestand",
    quantityToTransfer: "Zu transferierende Menge",
    addLine: "Zeile hinzufügen",
    selectProduct: "Produkt auswählen",
    removeLine: "Entfernen",
    providerOrder: "Anordnung des Anbieters",
    updatePos: "POS aktualisieren",
    pos: "POS",
    listPOS: "POS auflisten",
    createPOS: "POS erstellen",
    createNewPOS: "Neuen POS erstellen",
    viewPOS: "POS ansehen",
    createSale: "Verkauf erstellen",
    pointOfSale: "Kassenbereich",
    selectProducts: "Produkte auswählen",
    selectedItems: "Ausgewählte Artikel",
    noItemsSelected: "Keine Artikel ausgewählt",
    step1: "Schritt 1",
    step2: "Schritt 2",
    paymentMethods: "Zahlungsmethoden",
    received: "Erhalten",
    totalPaid: "Gesamt bezahlt",
    totalCash: "Gesamt Bargeld",
    totalCard: "Gesamt Karte",
    paymentCalculation: "Zahlungsberechnung",
    completeSale: "Verkauf abschließen",
    listOfSales: "Liste der Verkäufe",
    noTransactionsToday: "Keine Transaktionen heute",
    totalTransactions: "Gesamttransaktionen",
    active: "Aktiv",
    inactive: "Inaktiv",
    startCreatingNewPOSForYourCompany: "Beginnen Sie damit, neue POS für Ihr Unternehmen zu erstellen",
    add: "Hinzufügen",
    change: "Wechselgeld",
    cashier: "Kassierer",
    saleNumber: "Verkaufsnummer",
    viewSale: "Verkauf ansehen",
    return: "Zurückkehren",
    createNewSale: "Neuen Verkauf erstellen",
    defaultCustomerSale: "Standardkunde eines Verkaufs",
    heWantsAccessApplicationLink: "Er möchte über einen Link auf die Anwendung zugreifen",
    security: "Sicherheit",
    signOutAllDevices: "Von allen Geräten abmelden",
    editDeadlinePaymentParameter: "Modifier le paramètre de délai de paiement",
    editFeatureParameter: "Modifier le paramètre de fonctionnalité",
    editMeasureUnitParameter: "Modifier le paramètre d'unité de mesure",
    addMeasureUnitParameter: "Ajouter un paramètre d'unité de mesure",
    areYouSureYouWantToDeleteThisRecord: "Êtes-vous sûr de vouloir supprimer cet enregistrement ?",
    youWontBeAbleToRevertThis: "Vous ne pourrez pas annuler cette action",
    yesDeleteIt: "Oui, supprimer",
    confirmPurchase: "Kauf bestätigen",
    confirmPurchaseDesignMessage: "Möchten Sie den Kauf dieses Designs bestätigen?",
    yesPurchase: "Ja, kaufen",
    companyColorSettings: "Farbeinstellungen des Unternehmens",
    saveColors: "Farben speichern",
    companyDesignSettings: "Designeinstellungen des Unternehmens",
    currentDesign: "Aktuelles Design",
    setAsCurrent: "Als aktuell festlegen",
    subjectToVat: "Umsatzsteuerpflichtig",
    companySwitchingNotAvailableInView:
      "Der Unternehmenswechsel ist in dieser Ansicht nicht verfügbar; er kann nur in den allgemeinen Ansichten des Unternehmens durchgeführt werden",

    // Start sentence
    selectOneOption: "Wählen Sie eine der Optionen,",
    iAgree: "Ich stimme zu &",
    youWantToChangeOrderStatusTo: "Möchten Sie den Bestellstatus ändern zu",
    createdAt: "Erstellt am",
    updatedAt: "Aktualisiert am",
    validUntil: "Gültig bis",
    clickOn: "Klicken Sie auf",
    thisContactWillOnlyBeRegisteredInCompany: "Dieser Kontakt wird nur im Unternehmen registriert",
    securedPaymentBy: "Gesicherte Zahlung durch",
    anInvitationWillBeSent: "Eine Einladung zum Zugriff auf das Unternehmen wird gesendet",
    ifYouNeedMoreInfo: "Wenn Sie weitere Informationen benötigen, überprüfen Sie bei",
    theInvitationToAccess: "Die Einladung zum Zugriff auf das Unternehmen durch den Benutzer",
    theQuoteThatYouSent: "Das Angebot, das Sie an das Unternehmen gesendet haben",
    youHaveAlreadyEvaluatedOrder: "Sie haben die Bestellung des Unternehmens bereits bewertet",
    youHaveAlreadyEvaluatedQuote: "Sie haben das Angebot des Unternehmens bereits bewertet",
    youHaveAlreadyRespondedTo: "Sie haben bereits geantwortet auf",
    youHaveReceivedAQuote: "Sie haben ein Angebot vom Unternehmen erhalten",
    ifYouDoNotWishToExtendContactModificationsToOtherCompanies:
      "Wenn Sie die Kontaktänderungen nicht auf andere Unternehmen ausweiten möchten, markieren Sie keine und wählen Sie",
    youWantToChangeQuoteStatusTo: "Möchten Sie den Angebotsstatus ändern zu",
    youWantToChangeProviderOrderStatusTo: "Möchten Sie den Lieferantenbestellstatus ändern zu",
    theOrderThatYouSent: "Die Bestellung, die Sie an das Unternehmen gesendet haben",
    youHaveReceivedAnOrder: "Sie haben eine Bestellung vom Unternehmen erhalten",
    theCurrentCompanyIs: "Das aktuelle Unternehmen ist",
    toCreateA: "Erstellen Sie ein",
    createdBy: "Erstellt von",
    groupBy: "Gruppieren nach",
    checkOrUncheck: "Markieren oder deaktivieren Sie das",
    ifYouWishChangeVatRegimePleaseContact: "Wenn Sie das Umsatzsteuerregime ändern möchten, wenden Sie sich bitte an",
    ifYouInvalidateInvoice: "Wenn Sie die Rechnung ungültig machen",
    ifYouInvalidateProviderOrder: "Wenn dadurch die Bestellung des Lieferanten ungültig wird",
    ifYouInvalidateProvaiderInvoice: "Wenn Sie die Lieferantenrechnung ungültig machen",
    ifYouInvalidateExpense: "Wenn Sie die Ausgabe ungültig machen",
    the: "Die/Der/Das",
    planYourBusinessApplications: "Planen Sie Ihre Geschäftsanwendungen, indem Sie eine der folgenden auswählen",
    yourAccountIsNotVerified:
      "Ihr Konto ist nicht verifiziert. Bestätigen Sie Ihr Konto mit Ihrer E-Mail-Adresse, indem Sie auf die Schaltfläche klicken",
    chargeFor: "Belastung für",
    serverErrorOccurred: "Ein Serverfehler ist aufgetreten",
    noResponseServer: "Keine Antwort vom Server erhalten",
    serviceTemporarilyUnavailable: "Der Dienst ist vorübergehend nicht verfügbar. Bitte versuchen Sie es erneut.",
    records: "Aufzeichnungen",
    invitations: "Einladungen",
    consignment: "Konsignation",
    consignmentReturn: "Konsignations-Rücknahme",
    consignments: "Konsignationen",
    listConsignments: "Konsignationsliste",
    commissionType: "Provisionsart",
    commissionRate: "Provisionssatz",
    newConsignment: "Neue Vereinbarung",
    receiveProducts: "Produkte empfangen",
    returnProducts: "Unverkaufte zurückgeben",
    generateReport: "Bericht erstellen",
    quantitySold: "Verkaufte Menge",
    quantityReturned: "Zurückgegebene Menge",
    quantityAvailable: "Verfügbare Menge",
    quantityToReturn: "Zurückzugebende Menge",
    totalSoldValue: "Gesamtverkaufswert",
    commissionAmount: "Provisionsbetrag",
    amountDueToProvider: "Fälliger Betrag an Lieferant",
    closeAgreement: "Vereinbarung schließen",
    consignmentAgreement: "Konsignationsvereinbarung",
    fixedPrice: "Festpreis",
    documents: "Dokumente",
    document: "Dokument",
    listDocuments: "Dokumentenliste",
    uploadDocument: "Dokument hochladen",
    assignDocument: "Dokument zuweisen",
    archiveDocument: "Dokument archivieren",
    unarchiveDocument: "Dokument aus Archiv holen",
    ignoreDocument: "Dokument ignorieren",
    unignoreDocument: "Dokument wiederherstellen",
    inbox: "Posteingang",
    archives: "Archiv",
    youWantToIgnoreThisDocument: "Möchten Sie dieses Dokument wirklich ignorieren?",
    youWantToUnignoreThisDocument: "Möchten Sie dieses Dokument wirklich wiederherstellen?",
    youWantToArchiveThisDocument: "Möchten Sie dieses Dokument wirklich archivieren?",
    youWantToUnarchiveThisDocument: "Möchten Sie dieses Dokument wirklich aus dem Archiv holen?",
    successfullyIgnored: "Dokument erfolgreich ignoriert",
    successfullyUnignored: "Dokument erfolgreich wiederhergestellt",
    successfullyArchived: "Dokument erfolgreich archiviert",
    successfullyUnarchived: "Dokument erfolgreich aus dem Archiv geholt",
    cannotIgnoreDocument: "Dokument kann nicht ignoriert werden",
    cannotIgnoreDocumentWithAssignments: "Dieses Dokument hat aktive Zuweisungen. Entfernen Sie diese, bevor Sie es ignorieren.",
    deleteDocument: "Dokument löschen",
    fileName: "Dateiname",
    assignedTo: "Zugewiesen an",
    assigned: "Zugewiesen",
    preview: "Vorschau",
    downloadFile: "Datei herunterladen",
    upload: "Hochladen",
    assign: "Zuweisen",
    documentType: "Dokumenttyp",
    documentReference: "Dokumentreferenz",
    enterDocumentReference: "Dokumentreferenz eingeben",
    partiallyProcessed: "Teilweise verarbeitet",
    processed: "Verarbeitet",
    originalFile: "Originaldatei",
    documentDate: "Dokumentdatum",
    uploadedOn: "Hochgeladen am",
    documentDetails: "Dokumentdetails",
    documentName: "Dokumentname",
    previewNotAvailable: "Vorschau nicht verfügbar",
    documentUpdated: "Dokument aktualisiert",
    createFromDocument: "Aus Dokument erstellen",
    attachExistingDocument: "Vorhandenes Dokument anhängen",
    selectDocumentToAttach: "Dokument zum Anhängen auswählen",
    documentAttached: "Dokument erfolgreich angehängt",
    noDocumentsAvailable: "Keine Dokumente verfügbar",
    attach: "Anhängen",
    uploadNewPdf: "Neues PDF hochladen",
    removeDocument: "Entfernen",
    confirmRemoveVoucher: "Dieses Dokument entfernen?",

    // End sentence
    companyPleaseEvaluateQuote: ", bitte bewerten Sie das Angebot.",
    theAssociatedAccountingEntriesWillBeDeletedInvoice:
      ", die zugehörigen Buchungen werden gelöscht. Das bedeutet, dass Sie keine Zahlungen leisten oder Mahngebühren im Zusammenhang mit dieser Rechnung erstellen können.",
    theAssociatedAccountingEntriesWillBeDeletedProviderInvoice:
      ", die zugehörigen Buchungen werden gelöscht. Das bedeutet, dass Sie keine Zahlungen leisten oder Mahngebühren im Zusammenhang mit dieser Lieferantenrechnung erstellen können.",
    theAssociatedAccountingEntriesWillBeDeletedExpense:
      ", die zugehörigen Buchungen werden gelöscht. Das bedeutet, dass Sie keine Zahlungen leisten oder Mahngebühren im Zusammenhang mit dieser Ausgabe erstellen können.",
    theAssociatedProductsWillBeRemoved:
      ", werden die zugehörigen Produkte entfernt. Das bedeutet, dass sie nicht mehr im Bestand der Lagerzentren erfasst werden, die mit dieser Lieferantenbestellung verknüpft sind.",
    ifYouWishToSaveTheChangesMade: "wenn Sie die vorgenommenen Änderungen speichern möchten.",
    youWantToRun: "das Sie ausführen möchten.",
    toContinue: "um fortzufahren.",
    waitAMomentToVerifyYourAccess: "warten Sie einen Moment, um Ihren Zugriff zu überprüfen.",
    hasSentARequestForAccessToTheFollowingCompany: "hat eine Zugriffsanfrage für das folgende Unternehmen gesendet, bitte antworten Sie.",
    ifYouWantToSaveTheNewQuote: "wenn Sie das neue Angebot speichern möchten.",
    ifYouWantToSaveTheNewQuoteWithTheChangesMade: "wenn Sie das neue Angebot mit den vorgenommenen Änderungen speichern möchten.",
    ifYouWantToSaveTheNewInvoiceWithTheChangesMade: "wenn Sie die neue Rechnung mit den vorgenommenen Änderungen speichern möchten.",
    ifYouWantToSaveTheNewExpense: "wenn Sie die neue Ausgabe speichern möchten.",
    ifYouWantToSaveTheNewProviderInvoice: "wenn Sie die neue Lieferantenrechnung speichern möchten.",
    ifYouWantToSaveTheNewProviderOrder: "wenn Sie die neue Lieferantenbestellung speichern möchten.",
    ifYouWantToSaveTheNewProviderOrderWithTheChangesMade:
      "wenn Sie die neue Lieferantenbestellung mit den vorgenommenen Änderungen speichern möchten.",
    ifYouWantToSaveTheNewProviderInvoiceWithTheChangesMade:
      "wenn Sie die neue Lieferantenrechnung mit den vorgenommenen Änderungen speichern möchten.",
    ifYouWantToSaveTheNewOrder: "wenn Sie die neue Bestellung speichern möchten.",
    ifYouWantToSaveTheNewOrderWithTheChangesMade: "wenn Sie die neue Bestellung mit den vorgenommenen Änderungen speichern möchten.",
    companyPleaseEvaluateTheOrder: "Unternehmen, bitte bewerten Sie die Bestellung.",
    ifYouWantToSaveTheNewInvoice: "wenn Sie die neue Rechnung speichern möchten.",
    youWillNotBeAbleToRemoveItFromThisCompany:
      ", Sie werden es aus diesem Unternehmen nicht entfernen können, aber Sie können die anderen Unternehmen auswählen.",
    inThisCategory: "in dieser Kategorie.",
    theCompanyContainTreasutyAccount: "das Unternehmen muss mindestens ein Treasury-Konto enthalten.",
    toBeAddedInOrderToDownloadTheInvoice: "muss hinzugefügt werden, um die Rechnung herunterzuladen.",

    // All sentence
    enterNewPassword: "Geben Sie ein neues Passwort ein.",
    ifYouChangeYourMind: "Wenn Sie Ihre Meinung ändern, fordern Sie bitte eine neue Bewerbung an.",
    messageWillBeSentYourEmailToRecoverAccount:
      "Eine Nachricht wird an Ihre E-Mail gesendet, um das Konto wiederherzustellen. Bitte überprüfen Sie Ihre E-Mails. Sie werden zur Anmeldeseite weitergeleitet.",
    yuouCanNowStartUsingApp: "Sie können die App jetzt nutzen, Sie werden in Kürze auf die Startseite weitergeleitet.",
    newCompanyIsSelectedByDefault: "Das neue Unternehmen ist standardmäßig ausgewählt und wird auf die Hauptseite weitergeleitet.",
    notificationWillBeDeleted: "Die Einladungsbenachrichtigung zum Zugriff auf das Unternehmen wird gelöscht.",
    theAppWillBeTranslated:
      "Die Anwendung wird in die ausgewählte Sprache übersetzt, außer für die in den Dokumenten eingegebenen Informationen.",
    userWillRespondInvitation: "Der Benutzer wird antworten, ob er die Einladung zum Zugriff auf das Unternehmen akzeptiert oder ablehnt.",
    youWillNotBeAbleToUndo: "Sie können diese Aktion nicht rückgängig machen.",
    toValidateYourAccount:
      "Um Ihr Konto zu bestätigen, wird eine Nachricht an Ihre E-Mail-Adresse gesendet, in der Sie es verifizieren können.",
    pleaseCheckEmailToValidateAccount: "Bitte überprüfen Sie Ihre E-Mails, wir haben eine Nachricht gesendet, um Ihr Konto zu bestätigen.",
    anEmailSentToValidateAccount: "Eine E-Mail wurde an Sie gesendet, um Ihr Konto zu bestätigen.",
    validatedAccountForLoggedInUser: "Konto für den angemeldeten Benutzer validiert, Weiterleitung zur Hauptseite.",
    validatedAccountForADifferentUser:
      "Konto für einen anderen Benutzer als den aktuell angemeldeten validiert, Weiterleitung zur Anmeldeseite.",
    validatedVerifiedForAUserWhoHasNotLoggedIn:
      "Für einen Benutzer, der sich nicht angemeldet hat, validiert und verifiziert, Weiterleitung zur Anmeldeseite.",
    newServicesWithinTheSameApp: "Neue Dienste innerhalb derselben Anwendung.",
    soonYouWillBeAbleToAccessNewFunctionalities: "Bald können Sie auf neue Funktionen innerhalb der Anwendung zugreifen.",
    pleaseCorrectThePathOfThePageInOrderToAccess: "Bitte korrigieren Sie den Seitenpfad, um auf die Anwendung zuzugreifen.",
    pleaseTryAgainLater: "Bitte versuchen Sie es später erneut.",
    validTokenAutomaticLoginRedirectedDashboard: "Gültiges Token, automatische Anmeldung, Weiterleitung zur Dashboard-Seite.",
    redirectingToLogin: "Weiterleitung zur Anmeldeseite.",
    willNotBeAbleToReturnUntilYouLogin: "Sie können nicht zurückkehren, bis Sie sich erneut anmelden.",
    enterEmailWhetherBelongsRegisteredUserOrNot:
      "Geben Sie die E-Mail-Adresse ein, unabhängig davon, ob sie einem registrierten Benutzer gehört oder nicht. Es wird eine Benachrichtigung gesendet, um auf die Anwendung und das Unternehmen zuzugreifen, entweder innerhalb der Anwendung (falls der Benutzer existiert) oder an die angegebene E-Mail-Adresse.",
    theFileMustBeFormat: "Die Datei muss im Format jpeg, jpg oder png vorliegen.",
    ifYouHaveAnyQuestionsContactUs: "Wenn Sie Fragen haben, können Sie uns kontaktieren.",
    noNotificationsSeenYet: "Es wurden noch keine Benachrichtigungen gesehen.",
    thereAreNoNotifications: "Es wurden noch keine Benachrichtigungen empfangen.",
    invitationsHaveNotReceived: "Es sind noch keine Einladungen eingegangen.",
    byDefaultValuesOfTheCompanyAreTaken: "Standardmäßig werden die Werte des Unternehmens übernommen.",
    selectTheOptionsThatBestConsiderWhenDownloading:
      "Wählen Sie die Optionen aus, die Sie beim Herunterladen eines Angebots oder einer Rechnung im PDF-Format für am besten halten.",
    notificationsAboutInvitationsToSubscribe: "Benachrichtigungen über Einladungen zum Abonnieren und Zugriff auf ein Unternehmen.",
    whenCreatingAContactByUUID:
      "Beim Erstellen eines Kontakts über UUID können bestimmte Felder je nach Typ nicht geändert werden: Person (Name, Nachname, E-Mail) und Unternehmen (Name).",
    youCanDirectlyEnterUUIDOfAUserOrCompanyToAddAsContact:
      "Sie können die UUID eines Benutzers oder Unternehmens direkt eingeben, um diesen als Kontakt hinzuzufügen. Andernfalls wählen Sie den gewünschten Kontakttyp aus.",
    descriptionCreateQuote: "Geben Sie die folgenden Details ein, diese sind erforderlich, um ein neues Angebot zu erstellen.",
    descriptionCreateOrder: "Geben Sie die folgenden Details ein, diese sind erforderlich, um eine neue Bestellung zu erstellen.",
    descriptionCreateInvoice: "Geben Sie die folgenden Details ein, diese sind erforderlich, um eine neue Rechnung zu erstellen.",
    sorryLooksLikeThereAreSomeErrorstryAgain: "Entschuldigung, es wurden einige Fehler festgestellt, bitte versuchen Sie es erneut.",
    sorryLooksLikeThereAreSomeErrorsTrySolve:
      "Entschuldigung, es wurden einige Fehler festgestellt, bitte versuchen Sie, diese zu beheben.",
    sorryThereIsNothingToAdd: "Entschuldigung, es gibt nichts hinzuzufügen, bitte versuchen Sie es erneut.",
    thankYouVeryMuchForSubscribingRedirectingToPreviousPage: "Vielen Dank für Ihr Abonnement, Weiterleitung zur vorherigen Seite.",
    actionCompletedReturningToPage: "Aktion abgeschlossen, Rückkehr zur Seite.",
    actionCompletedRedirectingToPage: "Aktion abgeschlossen, Weiterleitung zur Seite.",
    pleaseModifyAddOrDeleteFieldsFromQuote: "Bitte ändern, fügen Sie hinzu und/oder löschen Sie die gewünschten Felder aus dem Angebot.",
    thisOptionIsUniqueAndNewOrderCannotBeCreatedFromThisQuote:
      "Diese Option ist einzigartig und es kann keine neue Bestellung aus diesem Angebot erstellt werden.",
    descriptionCreateProviderInvoice:
      "Geben Sie die folgenden Details ein, diese sind erforderlich, um eine neue Lieferantenrechnung zu erstellen.",
    pleaseModifyAddOrDeleteFieldsFromProviderInvoice:
      "Ändern, fügen Sie hinzu und/oder löschen Sie die gewünschten Felder aus der Lieferantenrechnung.",
    pleaseModifyAddOrDeleteFieldsFromExpense: "Ändern, fügen Sie hinzu und/oder löschen Sie die gewünschten Felder aus der Ausgabe.",
    descriptionCreateExpense: "Bitte geben Sie die folgenden Details ein, diese sind erforderlich, um eine neue Ausgabe zu erstellen.",
    descriptionCreateProviderOrder:
      "Geben Sie die folgenden Details ein, diese sind erforderlich, um eine neue Lieferantenbestellung zu erstellen.",
    pleaseModifyAddOrDeleteFieldsFromProviderOrder:
      "Ändern, fügen Sie hinzu und/oder löschen Sie die gewünschten Felder aus der Lieferantenbestellung.",
    fileFormatMaximum10MBPerFile: "Dateiformat ist '.pdf' und die maximale Dateigröße beträgt 10 MB.",
    someOfTheUploadedFilesDoNotMeetTheRequiredCharacteristics:
      "Einige der hochgeladenen Dateien erfüllen nicht die erforderlichen Kriterien.",
    pleaseModifyAddOrDeleteFieldsFromOrder: "Ändern, fügen Sie hinzu und/oder löschen Sie die gewünschten Felder aus der Bestellung.",
    pleaseModifyAddOrDeleteFieldsFromInvoice: "Ändern, fügen Sie hinzu und/oder löschen Sie die gewünschten Felder aus der Rechnung.",
    thisAmountCanNotBeGreater: "Dieser Betrag darf nicht größer als die Gesamtschuld der Rechnung sein.",
    amountMinOfDueAndTransaction: "Minimum aus fälligem Rechnungsbetrag und Transaktionsbetrag.",
    toCreateAnDocument: "Um ein Dokument zu erstellen, muss das Unternehmen mindestens ein Treasury-Konto enthalten.",
    newContactWwillAddedToCompanyAndSelectDefault:
      "Neuer Kontakt wird dem Unternehmen hinzugefügt und als Standard ausgewählt, Rückkehr zur Seite.",
    youHaveSuccessfullyResetYourPassword:
      "Sie haben Ihr Passwort erfolgreich zurückgesetzt, Sie können sich nun erneut anmelden. Sie werden zur Anmeldeseite weitergeleitet.",
    ifNoAmountIsEnteredTheValueWillBeZero: "Wenn kein Betrag eingegeben wird, beträgt der Wert 0.",
    ifYouWishYouCanAssignNameInLanguagesNecessary:
      "Wenn Sie möchten, können Sie den Namen in den Sprachen zuweisen, die Sie für erforderlich halten.",
    productNameRequiredAndRecommendedUnique: "Ein Produktname ist erforderlich und es wird empfohlen, dass er eindeutig ist.",
    addProductToCategory: "Fügen Sie ein Produkt zu einer Kategorie hinzu.",
    addTagsToProduct: "Fügen Sie dem Produkt Tags hinzu, sie sind optional.",
    setProductMediaGallery: "Richten Sie die Produkt-Mediengalerie ein.",
    serviceNameRequiredAndRecommendedUnique: "Ein Service-Name ist erforderlich und es wird empfohlen, dass er eindeutig ist.",
    addServiceToCategory: "Fügen Sie einen Service zu einer Kategorie hinzu.",
    addTagsToService: "Fügen Sie dem Service Tags hinzu, sie sind optional.",
    setServiceMediaGallery: "Richten Sie die Service-Mediengalerie ein.",
    aCategoryContainServicesProducts: "Eine Kategorie kann sowohl Dienste als auch Produkte enthalten.",
    ifSoAdditionalInformationRequired: "Falls ja, werden zusätzliche Informationen benötigt.",
    toPerformAnySubsequentActionWithInvoice:
      "Um nachfolgende Aktionen mit der Rechnung auszuführen, muss sie erneut validiert werden, indem die entsprechenden Buchhaltungskonten für jedes zugehörige Produkt und/oder jede Dienstleistung angegeben werden.",
    toPerformAnySubsequentActionWithProviderInvoice:
      "Um nachfolgende Aktionen mit der Lieferantenrechnung auszuführen, muss sie erneut validiert werden, indem die entsprechenden Buchhaltungskonten für jedes zugehörige Produkt und/oder jede Dienstleistung angegeben werden.",
    toPerformAnySubsequentActionWithExpense:
      "Um nachfolgende Aktionen mit der Ausgabe auszuführen, muss sie erneut validiert werden, indem die entsprechenden Buchhaltungskonten für jedes zugehörige Produkt und/oder jede Dienstleistung angegeben werden.",
    toPerformAnyFurtherActionProviderOrder:
      "Um mit der Bestellung des Anbieters weitere Maßnahmen durchführen zu können, ist es notwendig, eine Kopie davon zu erstellen.",
    validatingInvoiceSystemWillCreateToFollowingAccountingEntries:
      "Durch die Validierung der Rechnung erstellt das System die folgenden Buchungseinträge. Bestätigen Sie die Buchhaltungskonten für jeden Service oder jedes Produkt in der Rechnung.",
    validatingProviderInvoiceSystemWillCreateToFollowingAccountingEntries:
      "Durch die Validierung der Lieferantenrechnung erstellt das System die folgenden Buchungseinträge. Bestätigen Sie die Buchhaltungskonten für jeden Service oder jedes Produkt in der Lieferantenrechnung.",
    validatingExpenseSystemWillCreateToFollowingAccountingEntries:
      "Durch die Validierung der Ausgabe erstellt das System die folgenden Buchungseinträge. Bestätigen Sie die Buchhaltungskonten für jeden Service oder jedes Produkt in der Ausgabe.",
    allowedFileTypes: "Erlaubte Dateitypen: png, jpg, jpeg.",
    whenYouUploadPdfFilesTheyArePlacedReferenceSupplieIinvoiceCreationform:
      "Wenn Sie eine oder mehrere PDF-Dateien hochladen, werden diese als Referenz im Formular zur Erstellung der Lieferantenrechnung platziert.",
    someFilesIncorrectlyFormattedAndTooLarge: "Einige Dateien sind falsch formatiert, andere sind zu groß.",
    someFilesIncorrectlyFormatted: "Einige Dateien sind falsch formatiert.",
    someFilesTooLarge: "Einige Dateien sind zu groß.",
    searchSelectContact: "Suchen und wählen Sie einen Kontakt aus.",
    accountingBookWithTotalAccountingEntriesCompany: "Buchhaltungsbuch mit den gesamten Buchungseinträgen des Unternehmens.",
    byDefaultSimpleWriting: "Standardmäßig wird eine einfache Buchung erstellt.",
    selectAllPossibleOptions: "Wählen Sie alle möglichen Optionen aus.",
    newManualAccountingBookCreated: "Ein neues manuelles Buchhaltungsbuch wird erstellt.",
    selectOptionToEnableForm: "Wählen Sie eine Option, um das Formular zu aktivieren.",
    selectApplicableScheme: "Wählen Sie das geltende System aus.",
    enterApplicableVatRate: "Geben Sie den geltenden Mehrwertsteuersatz ein.",
    theSystemAddingFollowingProductsToCompanyInventoryProviderOrder:
      "Das System fügt dem Firmenbestand die folgenden Produkte hinzu. Bitte bestätigen Sie die Lagerorte für jedes Produkt in der Lieferantenbestellung.",
    theSystemAddingFollowingProductsToCompanyInventoryProviderInvoice:
      "Das System fügt dem Firmenbestand die folgenden Produkte hinzu. Bitte bestätigen Sie die Lagerorte für jedes Produkt in der Lieferantenbestellung.",
    addPaymentUsingCashOrCardOrDeposit: "Fügen Sie eine Zahlung per Bargeld, Karte oder Einzahlung hinzu.",

    // Lowercase sentences
    yearl: "jahr",
    years: "jahre",
    hour: "stunde",
    hours: "stunden",
    minute: "minute",
    minutes: "minuten",
    items: "elemente",
    groups: "gruppen",
    selected: "ausgewählt",
    accountNeedsA: "konto benötigt ein",
    options: "optionen",
    with: "mit",
    bestCustomers: "beste Kunden",
    byRecentUpdates: "nach neuesten Aktualisierungen",
    byTimeRange: "nach Zeitraum",
    template: "vorlage",
    evaluated: "bewertet",
    noMailFound: "keine E-Mail gefunden",
    report: "bericht",
    reports: "berichte",
    requestOnAccess: "anfrage für unternehmenszugang, ihre antwort war",
    userHasBeen: "wurde",
    yourAnswerHasBeen: ", ihre Antwort war",
    toUser: "an Benutzer",
    hasBeen: "wurde",
    byYear: "nach Jahr",
    or: "oder",
    quotesToExpireThisMonth: "angebote, die in diesem Monat ablaufen",
    worstCustomers: "schlechteste Kunden",
    button: "schaltfläche",
    termsAndConditions: "geschäftsbedingungen",
    and: "und",
    ourServicesOrRequesting: "unsere Dienste oder eine neue Anfrage",
    toAddOrRemoveCategory: "die Sie zur Kategorie hinzufügen oder entfernen möchten",
    orCall: "oder rufen Sie an",
    invoicesNotYetPaid: "rechnungen noch nicht bezahlt",
    collections: "forderungen",
    from: "von",

    // Interrogative sentences
    isDeliveryAddressTheSameAsCustomersAddress: "Ist die Lieferadresse dieselbe wie die Adresse des Kunden?",
    youWantLogOut: "Möchten Sie sich abmelden?",
    doesItTakeALongTimeToLoadTheApp: "Dauert das Laden der App lange?",
    alreadyHaveAnCccount: "Haben Sie bereits ein Konto?",
    forgotPassword: "Passwort vergessen?",
    newHere: "Neu hier?",
    doYouWantToSendInvitation: "Möchten Sie eine Einladung zum Zugang zum Unternehmen senden?",
    selectThisTreasuryAccountAsTheMainOne: "Dieses Treasury-Konto als Hauptkonto auswählen?",
    youWantToDeleteThisTreasuryAccount: "Möchten Sie dieses Treasury-Konto löschen?",
    youWantToSelectThisTreasuryAccountAsPrimary: "Möchten Sie dieses Treasury-Konto als primär auswählen?",
    wantToExtendChangesToOtherCompanies: "Möchten Sie die Änderungen auf andere Unternehmen ausweiten?",
    youWantToDeleteThisContact: "Möchten Sie diesen Kontakt löschen?",
    youWantToDeleteSelectedContacts: "Möchten Sie die ausgewählten Kontakte löschen?",
    youWantSendQuote: "Möchten Sie das Angebot an den Kunden senden?",
    youWantToChangeQuoteStatusRejected: "Möchten Sie den Angebotsstatus auf abgelehnt ändern?",
    youWantToGenerateAnOrderFromThisQuote: "Möchten Sie aus diesem Angebot eine Bestellung erzeugen?",
    youWantToChangeStatusTheExpense: "Möchten Sie den Ausgabenstatus ändern?",
    youWantToDeleteThisDocument: "Möchten Sie dieses Dokument löschen?",
    youWantToRevertThisDocumentToDraft: "Möchten Sie dieses Dokument in den Entwurfsstatus zurücksetzen?",
    youWantToDeleteThisExpense: "Möchten Sie diese Ausgabe löschen?",
    youWantToChangeStatusTheProviderInvoice: "Möchten Sie den Status der Lieferantenrechnung ändern?",
    youWantToGenerateAProviderInvoiceFromThisProviderOrder:
      "Möchten Sie aus dieser Lieferantenbestellung eine Lieferantenrechnung erstellen?",
    youWantToChangeOrderStatusToCanceled: "Möchten Sie den Bestellstatus auf storniert ändern?",
    youWantToGenerateAnInvoiceFromThisOrder: "Möchten Sie aus dieser Bestellung eine Rechnung erstellen?",
    youWantToSendTheOrderToCustomer: "Möchten Sie die Bestellung an den Kunden senden?",
    youWantToCreateDeliveryNote: "Möchten Sie einen Lieferschein erstellen?",
    aFullDeliveryNoteWillBeCreated: "Ein vollständiger Lieferschein wird für alle Artikel dieser Bestellung erstellt",
    youWantToSendDeliveryNote: "Möchten Sie diesen Lieferschein senden?",
    youWantToDeleteThisPayment: "Möchten Sie diese Zahlung löschen?",
    youWantToChangeStatusTheInvoice: "Möchten Sie den Rechnungsstatus ändern?",
    isCompanyOwnerOfBankAccount: "Ist das Unternehmen Eigentümer des Bankkontos?",
    useReferenceWithinQR: "Eine Referenz im QR verwenden?",
    youWantDeleteProduct: "Möchten Sie dieses Produkt löschen?",
    youWantDeleteSelectedProducts: "Möchten Sie die ausgewählten Produkte löschen?",
    youWantToDeleteThisReminder: "Möchten Sie diese Erinnerung löschen?",
    youWantToDeleteThisCategory: "Möchten Sie diese Kategorie löschen?",
    youWantToDeleteTheStorageCenter: "Möchten Sie das Speichercenter löschen?",
    youWantToDeleteSelectedCategories: "Möchten Sie die ausgewählten Kategorien löschen?",
    youWantToDeleteTheStorageCenters: "Möchten Sie die Speicherzentren löschen?",
    youWantDeleteService: "Möchten Sie diesen Dienst löschen?",
    youWantDeleteSelectedServices: "Möchten Sie die ausgewählten Dienste löschen?",
    isCompanySubjectVat: "Ist das Unternehmen umsatzsteuerpflichtig?",
    wouldYouLikeUploadPdfFilesToRegistrationNnewInvoice:
      "Möchten Sie eine oder mehrere PDF-Dateien hochladen, um die Registrierung einer neuen Rechnung zu erleichtern?",
    howWouldLikeDeclareVat: "Wie möchten Sie die Mehrwertsteuer deklarieren?",
    youWantToDeleteThisPOS: "Möchten Sie diesen POS löschen?",
    doYouWantJoinNewCompany: "Möchtest du dem neuen Unternehmen beitreten?",
    youWantToSendByEmail: "Möchten Sie dieses Dokument per E-Mail senden?",
    youWantToSendToCustomer: "Möchten Sie dies an den Kunden senden?",
    youWantToDeleteThisAddress: "Möchten Sie diese Adresse löschen?",
    youWantToSetDefaultAddress: "Möchten Sie diese Adresse als Standard festlegen?",
    youWantToRejectQuote: "Möchten Sie dieses Angebot ablehnen?",
    youWantToRejectOrder: "Möchten Sie diese Bestellung ablehnen?",
    brands: "Marken",
    youWantToDeleteThisBrand: "Möchten Sie diese Marke löschen?",
    listBrands: "Markenliste",
    createBrand: "Marke erstellen",
    searchBrand: "Marke suchen",
    clear: "Löschen",
    sortBy: "Sortieren nach",
    show: "Anzeigen",
    perPage: "Pro Seite",
    showing: "Anzeige",
    of: "von",
    nameRequired: "Name ist erforderlich",
    nameIsRequired: "Name ist erforderlich",
    updateBrand: "Marke aktualisieren",
    enterBrandName: "Markennamen eingeben",
    logoUrlHint: "Logo-URL-Hinweis",
    processing: "Verarbeitung",
    editBrand: "Marke bearbeiten",
    logoUrl: "Logo-URL",
    addBrand: "Marke hinzufügen",
    selectBrand: "Marke auswählen",
    noBrandsAvailable: "Keine Marken verfügbar",

    // Exclamative sentences
    important: "Wichtig!",
    exclamError: "Fehler!",
    networkError: "Netzwerkfehler!",
    httpError: "HTTP-Fehler!",
    yourSessionHasBeenClosed: "Ihre Sitzung wurde geschlossen, bitte melden Sie sich an!",
    yourSessionHasExpired: "Ihre Sitzung ist abgelaufen, bitte melden Sie sich erneut an!",
    accountNotValidated: "Konto noch nicht bestätigt!",
    newRegisteredUser: "Neuer Benutzer registriert!",
    moneyBackGuarantee: "100% Geld-zurück-Garantie!",
    somethingWentWrong: "Etwas ist schiefgelaufen!",
    thePageYouLookedNotFound: "Die von Ihnen gesuchte Seite wurde nicht gefunden!",
    yourSessionIsActiveCongratulations: "Ihre Sitzung ist aktiv, Glückwunsch!",
    weNeedYourAttention: "Wir benötigen Ihre Aufmerksamkeit!",
    yourAreDone: "Fertig!",
    startCreatingNewTreasuryAccountsForYourCompany:
      "Beginnen Sie mit der Erstellung neuer Treasury-Konten für Ihr Unternehmen, dies ist sehr wichtig für die Funktionalität der App!",
    itNotChangeCompany: "Es ist nicht möglich, das Unternehmen zu wechseln!",
    weAreWorkingFeature: "Wir arbeiten an dieser Funktion. Sie wird in Kürze verfügbar sein!",
    processOfCreatingANewInvoiceCompleted: "Der Vorgang zum Erstellen einer neuen Rechnung wurde abgeschlossen!",
    processOfUpdatingAInvoiceCompleted: "Der Vorgang zum Aktualisieren einer Rechnung wurde abgeschlossen!",
    thereAreNoTreasuryAccounts: "Es gibt keine Treasury-Konten!",
    incorrectFiles: "Falsche Dateien!",
    startAddingNewElementsToThisCategory: "Beginnen Sie, neue Elemente zu dieser Kategorie hinzuzufügen!",
    accountingAccountAlreadySelected: "Buchhaltungskonto bereits ausgewählt, bitte wählen Sie ein anderes!",
    servicesProductsWithTaxGreaterThanZero: "Dienstleistungen oder Produkte mit Steuer größer als Null!",
    youHaveSuccessfullySignedOut: "Sie haben sich erfolgreich abgemeldet!",
    selectContactViewTheirAccountStatement: "Wählen Sie einen Kontakt aus, um seinen Kontoauszug zu sehen!",
    processOfCreatingANewOrderCompleted: "Der Vorgang zum Erstellen einer neuen Bestellung wurde abgeschlossen!",
    processOfUpdatingAnOrderCompleted: "Der Vorgang zum Aktualisieren einer Bestellung wurde abgeschlossen!",
    processOfCreatingQuoteCompleted: "Der Vorgang zum Erstellen eines neuen Angebots wurde abgeschlossen!",
    processOfCreatingAQuoteFromAnotherQuoteCompleted:
      "Der Vorgang zum Erstellen eines Angebots aus einem anderen Angebot wurde abgeschlossen!",
    processOfCreatingAOrderFromAnotherOrderCompleted:
      "Der Vorgang zum Erstellen einer Bestellung aus einer anderen Bestellung wurde abgeschlossen!",
    processOfCreatingAInvoiceFromAnotherInvoiceCompleted:
      "Der Vorgang zum Erstellen einer Rechnung aus einer anderen Rechnung wurde abgeschlossen!",
    processOfUpdatingAQuoteCompleted: "Der Vorgang zum Aktualisieren eines Angebots wurde abgeschlossen!",
    processOfCreatingANewExpenseCompleted: "Der Vorgang zum Erstellen einer neuen Ausgabe wurde abgeschlossen!",
    processOfUpdatingAnExpenseCompleted: "Der Vorgang zum Aktualisieren einer Ausgabe wurde abgeschlossen!",
    processOfCreatingANewProviderInvoiceCompleted: "Der Vorgang zum Erstellen einer neuen Lieferantenrechnung wurde abgeschlossen!",
    processOfUpdatingAProviderInvoiceCompleted: "Der Vorgang zum Aktualisieren einer Lieferantenrechnung wurde abgeschlossen!",
    processOfCreatedAProviderOrderCompleted: "Der Vorgang zum Erstellen einer Lieferantenbestellung wurde abgeschlossen!",
    processOfCreatedAProviderInvoiceCompleted: "Der Vorgang zum Erstellen einer Lieferantenrechnung wurde abgeschlossen!",
    processOfCreatingANewProviderOrderCompleted: "Der Vorgang zum Erstellen einer neuen Lieferantenbestellung wurde abgeschlossen!",
    processOfUpdatingAProviderOrderCompleted: "Der Vorgang zum Aktualisieren einer Lieferantenbestellung wurde abgeschlossen!",
    successfullyCreatedAccountingAccount: "Buchhaltungskonto erfolgreich erstellt!",
    successfullyCreatedCategory: "Kategorie erfolgreich erstellt!",
    successfullyUpdatedCategory: "Kategorie erfolgreich aktualisiert!",
    successfullyInvitationSent: "Einladung erfolgreich gesendet!",
    successfullyInvitationCancel: "Einladung erfolgreich storniert!",
    successfullyCreatedContact: "Kontakt erfolgreich erstellt!",
    successfullyUpdatedContact: "Kontakt erfolgreich aktualisiert!",
    successfullyCreatedReminder: "Erinnerung erfolgreich erstellt!",
    successfullyUpdatedStatus: "Status erfolgreich aktualisiert!",
    successfullyUpdatedReminder: "Erinnerung erfolgreich aktualisiert!",
    successfullyCreatedPayment: "Zahlung erfolgreich erstellt!",
    successfullyCreatedCompanyParameters: "Unternehmensparameter erfolgreich erstellt!",
    successfullyUpdatedTreasuryAccount: "Treasury-Konto erfolgreich aktualisiert!",
    successfullyAcceptedInvitation: "Einladung erfolgreich angenommen!",
    successfullyLoggedIn: "Sie haben sich erfolgreich angemeldet!",
    successfullyUpdatedCompanySettings: "Unternehmenseinstellungen erfolgreich aktualisiert!",
    successfullyCreatedCompany: "Unternehmen erfolgreich erstellt!",
    successfullyDeletedPayment: "Zahlung erfolgreich gelöscht!",
    successfullyCreatedInvoice: "Rechnung erfolgreich erstellt!",
    successfullyDeletedReminder: "Erinnerung erfolgreich gelöscht!",
    successfullyOrderSent: "Bestellung erfolgreich gesendet!",
    successfullyQuoteSent: "Angebot erfolgreich gesendet!",
    successfullyCreatedOrder: "Bestellung erfolgreich erstellt!",
    successfullyCreatedDeliveryNote: "Lieferschein erfolgreich erstellt!",
    successfullyDeliveryNoteSent: "Lieferschein erfolgreich gesendet!",
    successfullyCreatedTreasuryAccount: "Treasury-Konto erfolgreich erstellt!",
    successfullyUpdatedDefaultTreasuryAccount: "Standard-Treasury-Konto erfolgreich aktualisiert!",
    successfullyDeletedDocument: "Dokument erfolgreich gelöscht!",
    successfullyDeletedTreasuryAccount: "Treasury-Konto erfolgreich gelöscht!",
    successfullyCreatedAccountingEntry: "Buchung erfolgreich erstellt!",
    successfullyUpdatedAccountingEntry: "Buchung erfolgreich aktualisiert!",
    successfullyUpdatedBookingJournal: "Buchungsjournal erfolgreich aktualisiert!",
    successfulllyCreatedUser: "Benutzer erfolgreich erstellt!",
    successfullyCreatedStorageCenter: "Speicherzentrum erfolgreich erstellt! ",
    successfullyUpdatedStorageCenter: "Speicherzentrum erfolgreich aktualisiert!",
    successfullyCreatedStorageOperations: "Lageroperationen erfolgreich erstellt!",
    successfullyUpdatedPos: "Kassensystem erfolgreich erstellt!",
    successfullyUpdatedUser: "Benutzer erfolgreich aktualisiert!",
    successfullyAddedAddress: "Adresse erfolgreich hinzugefügt!",
    successfullyUpdatedAddress: "Adresse erfolgreich aktualisiert!",
    successfullyDeletedAddress: "Adresse erfolgreich gelöscht!",
    successfullySetDefaultAddress: "Standardadresse erfolgreich festgelegt!",
    successfullySentDocument: "Dokument erfolgreich gesendet!",
    successfullyUpdated: "Erfolgreich aktualisiert!",

    // Answer sentences
    okGotIt: "Ok, verstanden",
    yesLogOut: "Ja, abmelden",
    noCancel: "Nein, abbrechen",
    noContinue: "Nein, fortfahren",
    yesDelete: "Ja, löschen",
    yesResolveError: "Ja, den Fehler beheben",
    yesSelect: "Ja, auswählen",
    yesCanceled: "Ja, abbrechen",
    okClose: "Ok, schließen",
    yesReject: "Ja, ablehnen",
    yesGenerate: "Ja, erstellen",
    yesSend: "Ja, senden",
    yesChangeStatus: "Ja, Status ändern",
    yesCreateTreasuryAccount: "Ja, Treasury-Konto erstellen",
    yesValidate: "Ja, validieren",
    yesInvalidate: "Ja, ungültig machen",
    yesUpload: "Ja, hochladen",
    noContinueForm: "Nein, Formular fortsetzen",
    yesAdd: "Ja, hinzufügen",
    yesCreate: "Ja, erstellen",
    yesConfirm: "Ja, bestätigen",

    // Suspensive sentences
    pleaseWait: "Bitte warten...",
    selectOption: "Option auswählen...",
    searchContact: "Kontakt suchen...",
    searchCategory: "Kategorie suchen...",
    searchProduct: "Produkt suchen...",
    searchService: "Dienstleistung suchen...",
    searchStorage: "Lagerzentrum durchsuchen...",
    searchBookingJournal: "Buchungsjournal suchen...",
    searchAccountingAccount: "Buchhaltungskonto suchen...",
    select: "Auswählen...",
    search: "Suchen...",
    writeCommentToInvite: "Kommentar für die Einladung schreiben...",
    loading: "Lädt...",
    roles: "Rollen",
    noRolesAvailable: "Keine Rollen verfügbar",
    noRolesDefinedForCompany: "Für dieses Unternehmen sind keine Rollen definiert.",
    noAssignableRoles: "Ihre Rolle erlaubt es Ihnen nicht, Rollen zuzuweisen. Kontaktieren Sie einen Administrator.",
    roleNotAssignableByYou: "Ihre Rolle erlaubt es nicht, diese Rolle zuzuweisen",
    roleAssignmentForbidden: "Ihre Rolle erlaubt nicht, diese Rolle zuzuweisen",
    subscriptionExpiredAction: "Ihr Abonnement ist abgelaufen",
    system: "System",
    administration: "Verwaltung",
    admin: "Admin",
    member: "Mitglied",
    assignedRoles: "Zugewiesene Rollen",
    assignRole: "Zuweisen",
    removeRole: "Entfernen",
    manageRoles: "Rollen verwalten",
    revoke: "Widerrufen",
    reinvite: "Erneut einladen",
    invite: "Einladen",
    role: "Rolle",
    statusPending: "Ausstehend",
    statusAccepted: "Akzeptiert",
    statusRejected: "Abgelehnt",
    statusExpired: "Abgelaufen",
    expiresAt: "Läuft ab am",
    noMembers: "Keine Mitglieder gefunden",
    confirmRevoke: "Sind Sie sicher, dass Sie diese Einladung widerrufen möchten?",
    confirmRemoveRole: "Sind Sie sicher, dass Sie diese Rolle entfernen möchten?",
    policies: "Richtlinien",
    createRole: "Rolle erstellen",
    createPolicy: "Richtlinie erstellen",
    attachedPolicies: "Angehängte Richtlinien",
    attachPolicy: "Anhängen",
    detachPolicy: "Trennen",
    statements: "Anweisungen",
    addStatement: "Anweisung hinzufügen",
    removeStatement: "Anweisung entfernen",
    effect: "Wirkung",
    allow: "Erlauben",
    deny: "Verweigern",
    actionsList: "Aktionen",
    resources: "Ressourcen",
    resourcesHint: "Kommagetrennte Ressourcen-Identifikatoren, verwenden Sie * für alle",
    noRoles: "Keine Rollen gefunden",
    noPolicies: "Keine Richtlinien gefunden",
    confirmDeleteRole: "Sind Sie sicher, dass Sie diese Rolle löschen möchten?",
    confirmDeletePolicy: "Sind Sie sicher, dass Sie diese Richtlinie löschen möchten?",
    systemReadOnly: "Dies ist ein Systemelement und kann nicht geändert werden",
    loadingCatalog: "Ressourcenkatalog wird geladen...",
    emptyCatalog: "Keine Ressourcen verfügbar",
    advancedMode: "Erweitert",
    preview: "Vorschau",

    // Abbreviated sentences
    n: "Nr",
    mb: "MB",
    hrs: "std",
    min: "min",
    sec: "sek",

    // Enumeration
    first: "erste",
    second: "zweite",
    third: "dritte",
    fourth: "vierte",
    fifth: "fünfte",
    sixth: "sechste",

    // Languages
    english: "Englisch",
    french: "Französisch",
    italian: "Italienisch",
    german: "Deutsch",
    spanish: "Spanisch",

    // Months
    january: "Januar",
    february: "Februar",
    march: "März",
    april: "April",
    may: "Mai",
    june: "Juni",
    july: "Juli",
    august: "August",
    september: "September",
    october: "Oktober",
    november: "November",
    december: "Dezember",

    // Periods
    monthly: "Monatlich",
    quarterly: "Vierteljährlich",
    semiannual: "Halbjährlich",
    annual: "Jährlich",
    createAccount: "Konto erstellen",
    createSiblingAccount: "Geschwisterkonto erstellen",
    createChildAccount: "Unterkonto erstellen",
    siblingOf: "Geschwister von",
    subAccountOf: "Unterkonto von",
    nameFr: "Name (Französisch)",
    nameEn: "Name (Englisch)",
    nameDe: "Name (Deutsch)",
    nameIt: "Name (Italienisch)",
    codeAndNameFrRequired: "Code und französischer Name sind erforderlich",
    accountCreatedSuccessfully: "Konto erfolgreich erstellt",
    renameAccount: "Konto umbenennen",
    accountRenamedSuccessfully: "Konto erfolgreich umbenannt",
    siblingCodeHint: "4 Ziffern — z.B. 1005",
    childCodeHint: "XXXX.N — z.B. 1000.01",
    siblingAccount: "Geschwisterkonto",
    subAccount: "Unterkonto",
    referenceAccount: "Referenzkonto",
    creationMode: "Erstellungsmodus",
    foreignCurrency: "Fremdwährung",
    enableForeignCurrency: "In Fremdwährung fakturieren",
    exchangeRate: "Wechselkurs",
    exchangeDate: "Kursdatum",
    foreignCurrencyPreview: "Vorschau des umgerechneten Betrags",
    convertedTotal: "Umgerechneter Gesamtbetrag",
    rateInfo: "Wechselkurs-Info",
    amountInCurrency: "Betrag in {currency}",
    amountInCHF: "Betrag CHF",
    partialBalance: "Teilweise (ohne Umrechnung)",
    approxBalanceTooltip: "Zeile(n) ohne Wechselkurs — {currency}-Saldo geschätzt",
    partialLinesFooter: "teilweise ({count} Zeilen ohne Kurs)",
    currencyColumn: "Währung",
    vatPeriodicity: "MWST-Periodizität",
    firstPeriod: "Erste Periode",
    deductionMethod: "Abrechnungsmethode",
    methodInvoicing: "Nach vereinbartem Entgelt",
    methodCashing: "Nach vereinnahmtem Entgelt",
    periodConfigured: "Steuerperioden konfiguriert",
    periodOpen: "Offen",
    periodClosed: "Geschlossen",
    periodFiled: "Eingereicht",
    closePeriod: "Periode abschliessen",
    taxSettingsLocked: "Die MWST-Einstellungen sind gesperrt, da eine Steuerperiode erstellt wurde. Wenden Sie sich an Ihre Treuhandgesellschaft, um sie zu ändern.",
    taxSettingsLockedContact: "Wenn Sie das MWST-Regime ändern möchten, müssen Sie sich an",
    period: "Zeitraum",
    format: "Format",
    reconciliation: "Abstimmung",
    bankStatements: "Kontoauszüge",
    importStatement: "Auszug importieren",
    importBankStatement: "Kontoauszug importieren",
    allTreasuryAccounts: "Alle Finanzkonten",
    statementDate: "Auszugsdatum",
    openingBalance: "Anfangssaldo",
    closingBalance: "Schlusssaldo",
    importFailed: "Import fehlgeschlagen",
    dragAndDropOrClick: "Datei hierher ziehen oder klicken, um auszuwählen",
    importing: "Importieren...",
    importAction: "Importieren",
    autoMatchInfo: "Nach dem Import wird ein automatischer Abgleich gestartet, um Transaktionen mit bestehenden Rechnungen abzugleichen.",
    importSourceStructured: "Strukturierte Datei (CAMT/CSV)",
    importSourcePdfUpload: "PDF — hochladen",
    importSourcePdfExisting: "PDF — vorhandenes Dokument",
    extractingStatement: "Auszug wird extrahiert…",
    preparingDocument: "Dokument wird vorbereitet…",
    extractionFailed: "Extraktion fehlgeschlagen. Bitte erneut versuchen.",
    selectExistingDocument: "Vorhandenes Dokument auswählen",
    noPdfDocumentsAvailable: "Keine PDF-Dokumente verfügbar",
    retryExtraction: "Extraktion erneut starten",
    extractionTimeout: "Die Extraktion dauert länger als erwartet. Bitte versuchen Sie es später erneut.",
    jobQueued: "In Warteschlange...",
    jobFailed: "Fehlgeschlagen",
    heuristicSuggestions: "Heuristische Vorschläge",
    unmatchedLines: "Nicht zugeordnete Zeilen",
    bankTransactions: "Transaktionen",
    oneStatementNeedingAttention: "1 Auszug benötigt Aufmerksamkeit",
    statementsNeedingAttention: "Auszüge benötigen Aufmerksamkeit",
    someTransactionsNotReconciled: "Einige Transaktionen sind noch nicht abgestimmt",
    continueReconciliation: "Abstimmung fortsetzen",
    finishReconciliation: "Abstimmung abschliessen",
    counterpartIban: "Gegenpartei-IBAN",
    matchedVia: "Methode",
    noTransactionsFound: "Keine Transaktionen gefunden",
    viewStatement: "Beleg anzeigen",
    alreadyImported: "Bereits importiert",
    overlapWarning: "Dieser Zeitraum überschneidet sich mit {n} bereits importierten Auszug/Auszügen für dieses Konto.",
    duplicatesUnchecked: "{x} bereits vorhandene Transaktion(en) automatisch abgewählt.",
    includeLine: "Einschliessen",
    confirmed: "Bestätigt",
    sortByPeriod: "Nach Periode sortieren",
    confirmDeleteStatement: "Entwurfsauszug löschen?",
    confirmDeleteStatementText: "Dieser Entwurfsauszug und das zugehörige Dokument werden dauerhaft gelöscht. Diese Aktion kann nicht rückgängig gemacht werden.",
    existingPayments: "Bestehende Zahlungen",
    linkThisPayment: "Diese Zahlung verknüpfen",
    link: "Verknüpfen",
    autoMatchAll: "Auto-Abgleich",
    exportTransactions: "Transaktionen exportieren",
    reconcile: "Abgleichen",
    reconcileAutomatically: "Automatisch abgleichen",
    paid: "Bezahlt",
    entry: "Buchung",
    documentsToValidate: "Zu validierende Dokumente",
    validateAndReconcile: "Validieren und abgleichen",
    toValidate: "Zu validieren",
    dateFrom: "Von",
    dateTo: "Bis",
    resetFilters: "Zurücksetzen",
    transactions: "Transaktionen",
    previous: "Zurück",
    next: "Weiter",
    matched: "Abgestimmt",
    ignored: "Ignoriert",
    relaunchAutoMatch: "Auto-Abgleich neu starten",
    matching: "Abgleich",
    starting: "Starten",
    jobRunning: "Auto-Abgleich läuft",
    linesProcessed: "Verarbeitete Zeilen",
    noLinesPending: "Keine ausstehenden Zeilen",
    matchManually: "Manuell abgleichen",
    match: "Abgleichen",
    unmatch: "Abgleich aufheben",
    ignore: "Ignorieren",
    noLinesInStatement: "Keine Zeilen in diesem Auszug",
    statementNotFound: "Auszug nicht gefunden",
    confirmUnmatch: "Zuordnung aufheben?",
    unmatchWillDeleteEntry: "Die zugehörige Buchung könnte gelöscht werden.",
    yesUnmatch: "Ja, aufheben",
    confirmIgnore: "Diese Zeile ignorieren?",
    yesIgnore: "Ja, ignorieren",
    restoreLine: "Wiederherstellen",
    lineRestored: "Zeile auf ausstehend zurückgesetzt.",
    saveDraft: "Speichern",
    draftSaved: "Entwurf gespeichert.",
    savingDraft: "Speichern…",
    unsavedChanges: "Ungespeicherte Änderungen",
    unsavedChangesBody: "Sie haben ungespeicherte Änderungen. Was möchten Sie tun?",
    quitWithoutSaving: "Ohne Speichern verlassen",
    statementNotDraft: "Dieser Auszug ist kein Entwurf mehr. Neuladen…",
    jobAlreadyRunning: "Auto-Abgleich läuft bereits",
    noCandidatesFound: "Keine Kandidaten gefunden",
    reconcileAndCollect: "Abgleichen und einziehen",
    partialCollection: "Teilinkasso",
    score: "Punktzahl",
    pending: "Ausstehend",
    deleteStatement: "Auszug löschen",
    confirmDeleteStatementTitle: "Diesen Bankauszug löschen?",
    confirmDeleteStatementBody: "Diese Aktion löscht den Auszug und seine {count} nicht abgestimmte(n) Transaktion(en).",
    statementDeleted: "Auszug erfolgreich gelöscht.",
    cannotDeleteMatchedLines: "Löschen nicht möglich: {count} abgestimmte Transaktion(en). Lösen Sie zuerst die Abstimmungen.",
    cannotDeleteMatchedLinesTooltip: "Löschen nicht möglich: {count} abgestimmte Transaktion(en). Lösen Sie zuerst die Abstimmungen.",
    statementHasMatchedLinesError: "Dieser Auszug enthält {count} abgestimmte Transaktion(en). Lösen Sie diese vor dem Löschen.",
    invalidateStatement: "Ungültig machen",
    confirmInvalidateStatementTitle: "Diesen Bankauszug ungültig machen?",
    confirmInvalidateStatementBody: "Der Auszug wird zur Korrektur in den Entwurfsstatus zurückversetzt. Seine {count} Transaktion(en) stehen nicht mehr für die Abstimmung zur Verfügung. Das importierte Dokument bleibt angehängt.",
    statementInvalidated: "Auszug in Entwurfsstatus zurückversetzt.",
    confirmInvalidate: "Ja, ungültig machen",

    // VAT Return
    vatReturn: "MWST-Abrechnung",
    vatSectionTurnover: "I. Umsatz",
    vatSectionTaxCalculation: "II. Steuerberechnung",
    vatSectionOtherFlows: "III. Andere Mittelflüsse",
    vatTaxDue: "Geschuldete Steuer",
    vatInputTax: "Vorsteuer",
    vatBalance: "Saldo zugunsten ESTV / steuerpflichtiger Person",
    vatTax: "Steuer",
    vatCaseComposition: "Zusammensetzung der Ziffer",
    vatCounterServices: "Entgelte",
    vatDeductions: "Abzüge",
    vatTaxableTurnover: "Steuerbarer Umsatz",
    vatAmountToPayAFC: "An die ESTV zu bezahlender Betrag",
    vatBalanceInFavor: "Guthaben der steuerpflichtigen Person",
    vatTotalDeductions: "Total Abzüge",
    vatTotalTaxDue: "Total geschuldete Steuer",
    vatTotalInputTax: "Total Vorsteuer",
    vatNormalRate: "Leistungen zum Normalsatz",
    vatReducedRate: "Leistungen zum reduzierten Satz",
    vatAccommodationRate: "Leistungen zum Sondersatz Beherbergung",
    vatAcquisitions: "Bezugsteuer (netto, exkl. MWST)",
    caseNumber: "Ziffer",
    base: "Bemessungsgrundlage",
    sign: "Vorzeichen",
    nature: "Art",
    reference: "Referenz",
    back: "Zurück",
    accountingDocument: "Buchungsbeleg",
    documentNumber: "Belegnummer",
    entryNumber: "Buchungsnummer",
    entryNumberShort: "Nr.",
    manualEntry: "Manuelle Buchung",
    createAndReconcile: "Erstellen und abstimmen",
    gap: "Differenz",
    editVatAdjustment: "MWST-Anpassung bearbeiten",
    noteOptional: "Notiz (optional)",
    vouchersSoonAvailable: "Belege (demnächst verfügbar)",
    periodIsFiledCannotEdit: "Diese Periode ist abgeschlossen. Anpassungen können nicht geändert werden.",
    csvImport: "CSV-Import",
    difference: "Differenz",
    balanced: "Ausgeglichen",
    unbalanced: "Unausgeglichen",
    saveOpeningBalance: "Eröffnungsbilanz speichern",
    forceReprise: "Übernahme erzwingen",
    forceRepriseWarning: "Das vorherige Geschäftsjahr ist abgeschlossen. Das Erzwingen überschreibt die automatische Eröffnungsbuchung. Sind Sie sicher?",
    csvFormatHelp: "Akzeptierte CSV-Formate (Semikolon-Trennzeichen):",
    csvFormatBHelp: "1000;15000 (positiv = Soll, negativ = Haben)",
    closedFiscalYearReadonly: "Dieses Geschäftsjahr ist abgeschlossen. Die Eröffnungsbilanz kann nicht geändert werden.",
    deleteOpeningBalance: "Eröffnungsbilanz löschen",
    confirmDeleteOpeningBalance: "Möchten Sie die Eröffnungsbilanz wirklich löschen? Alle Beträge werden zurückgesetzt.",
    amountMustBePositive: "Der Betrag muss positiv sein — verwenden Sie die Soll- oder Haben-Spalte.",

    // Period status transitions
    filePeriod: "Einreichen",
    reopenPeriod: "Wieder öffnen",
    confirmClosePeriod: "Möchten Sie diese Periode wirklich abschliessen? Die Buchungen werden nicht mehr bearbeitbar sein, bis die Periode wieder geöffnet wird.",
    confirmFilePeriod: "Möchten Sie diese Periode wirklich einreichen? Diese Aktion ist endgültig und kann nicht rückgängig gemacht werden.",
    confirmFilePeriodWarning: "Nach der Einreichung wird die MwSt-Abrechnung eingefroren und keine Änderung mehr möglich sein.",
    confirmReopenPeriod: "Möchten Sie diese Periode wirklich wieder öffnen? Die Buchungen werden wieder bearbeitbar.",

    // Fiscal Years
    fiscalYears: "Geschäftsjahre",
    fiscalYear: "Geschäftsjahr",
    newFiscalYear: "Neues Geschäftsjahr",
    closeFiscalYear: "Geschäftsjahr abschliessen",
    closeFiscalYearConfirm: "Möchten Sie dieses Geschäftsjahr wirklich abschliessen? Diese Aktion ist unwiderruflich. Alle Buchungen werden gesperrt und keine weiteren Änderungen sind möglich.",
    closeFiscalYearWarning: "Diese Aktion ist unwiderruflich. Nach dem Abschluss können keine Buchungen mehr hinzugefügt oder geändert werden.",
    reopenFiscalYear: "Geschäftsjahr wiedereröffnen",
    reopenFiscalYearConfirm: "Möchten Sie dieses Geschäftsjahr wirklich wiedereröffnen?",
    reopenFiscalYearWarning: "Die Abschlussbuchung, die Eröffnungsbilanzvortrag und die Ergebniszuweisung des folgenden Geschäftsjahres werden gelöscht. Die Perioden werden wiedereröffnet. Sie können das Jahr danach erneut abschliessen.",
    reopenFiscalYearFirstReopen: "Eröffnen Sie zuerst das Geschäftsjahr {name} wieder",
    noFiscalYears: "Keine Geschäftsjahre gefunden",
    createFiscalYear: "Geschäftsjahr erstellen",
    editFiscalYear: "Geschäftsjahr bearbeiten",
    deleteFiscalYear: "Geschäftsjahr löschen",
    confirmDeleteFiscalYear: "Möchten Sie dieses Geschäftsjahr wirklich endgültig löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
    fiscalYearStartDate: "Startdatum des Geschäftsjahres",
    fiscalYearClosingYear: "Abschlussjahr",
    fiscalYearEndDate: "Enddatum des Geschäftsjahres",
    fiscalYearEndForced: "Das Geschäftsjahr endet immer am 31. Dezember",
    accountingSettingsInitializing: "Initialisierung läuft…",

    // Annual correction
    annualCorrection: "Jahreskorrektur",
    createAnnualCorrection: "Jahreskorrektur erstellen",
    viewAnnualCorrection: "Jahreskorrektur anzeigen",
    confirmCreateAnnualCorrection: "Jahreskorrektur für dieses Geschäftsjahr erstellen? Verwaiste Tickets werden in eine neue Korrekturperiode überführt.",
    periodsNotAllFiled: "Alle Perioden müssen eingereicht sein, bevor die Jahreskorrektur erstellt werden kann.",
    noOrphans: "Keine verwaisten Tickets für dieses Geschäftsjahr zu korrigieren.",
    ticketsPending: "Tickets ausstehend",

    // Vouchers
    confirmDeleteVoucher: "Möchten Sie diesen Beleg wirklich entfernen?",
    pendingUpload: "ausstehend",
    uploadFailed: "Der Upload ist für eine oder mehrere Dateien fehlgeschlagen. Betrag und Notiz wurden gespeichert.",
    addVoucher: "Beleg hinzufügen",

    // Manual entries
    vatInputType: "Art der Vorsteuer",
    vatInputGoods: "Waren und Material",
    vatInputInvestment: "Investitionen und übriger Betriebsaufwand",
    deleteAccountingEntry: "Buchung löschen",
    confirmDeleteAccountingEntry: "Möchten Sie diese Buchung wirklich löschen?",

    // Financial statements
    balanceSheet: "Bilanz",
    incomeStatement: "Erfolgsrechnung",
    trialBalance: "Saldobilanz",
    assets: "Aktiven",
    liabilities: "Passiven",
    revenue: "Ertrag",
    netResult: "Jahresergebnis",
    asOfDate: "Per",
    previousYear: "Vorjahr",
    variation: "Veränderung",
    notBalanced: "Nicht ausgeglichen",
    sortByCode: "Nach Konto sortieren",
    sortByBalance: "Nach Saldo sortieren",
    allLevels: "Alle Ebenen",
    profitOfYear: "Jahresgewinn",
    lossOfYear: "Jahresverlust",
    viewList: "Liste",
    viewColumns: "Nebeneinander",
    totalLiabilitiesAndResult: "Total Passiven & Ergebnis",
    viewVouchers: "Belege anzeigen",
    pendingDocuments: "ausstehende(s) Dokument(e)",
    showZeroAccounts: "Nullkonten anzeigen",
    hideZeroAccounts: "Nullkonten ausblenden",
    chatTitle: "Chat",
    chatConversations: "Konversationen",
    chatNewConversation: "Neue Konversation",
    chatNoConversations: "Noch keine Konversationen",
    chatNoMessages: "Noch keine Nachrichten. Sag Hallo!",
    chatPlaceholder: "Nachricht eingeben...",
    chatSend: "Senden",
    chatYou: "Sie",
    chatBack: "Zurück",
    chatStartConversation: "Chat",
    chatSelectMember: "Mitglied auswählen",
    chatLoadingMembers: "Mitglieder laden...",
    chatNoMembers: "Keine Mitglieder gefunden",
    chatLoadingMessages: "Nachrichten laden...",
    chatActive: "Aktiv",
    featureLabelContacts: "Kontakte & CRM",
    featureLabelSaleCore: "Verkauf & Rechnungsstellung",
    featureLabelPurchaseCore: "Einkauf & Lieferantenrechnungen",
    featureLabelTreasuryPayments: "Zahlungen & Bankabgleich",
    featureLabelCatalog: "Produkt- & Dienstleistungskatalog",
    featureLabelAccountingCore: "Buchhaltung",
    featureLabelArchiveOcr: "Dokumentenarchiv & OCR",
    featureLabelNetworkInterbilling: "Konzernverrechnung",
    featureLabelPaymentOnline: "Online-Zahlungen",
    featureLabelDunning: "Mahnwesen & Zahlungserinnerungen",
    featureLabelSaleRecurring: "Wiederkehrende Rechnungen",
    featureLabelTreasuryEbanking: "E-Banking-Anbindung",
    featureLabelTreasuryForecast: "Liquiditätsprognose",
    featureLabelProjectsTime: "Projekte & Zeiterfassung",
    featureLabelPos: "Kassensystem",
    featureLabelExpenses: "Spesenabrechnung",
    featureLabelInventory: "Lagerverwaltung",
    featureLabelSaleConsignment: "Konsignationsverkauf",
    featureLabelAccountingAssets: "Anlagenbuchhaltung",
    featureLabelServiceRepair: "Service- & Reparaturverfolgung",
    featureLabelRbacAdvanced: "Erweiterte Zugriffskontrolle",
    featureLabelMultiCompany: "Mehrfirmen-Verwaltung",
    featureLabelPayroll: "Lohnbuchhaltung",
    featureLabelStorefront: "Online-Shop",
    featureLabelEsignature: "Elektronische Unterschrift",
    featureLabelMobileSale: "Mobile Verkaufs-App",
    featureLabelMobileExpenses: "Mobile Spesenerfassung",
    featureLabelSupportPriority: "Prioritäts-Support",
    searchDocuments: "Dokumente durchsuchen",
    searchDocumentsPlaceholder: "Dokumente durchsuchen (Name, OCR-Inhalt)...",
    searchingDocuments: "Suche läuft...",
    searchDocumentsResultsCount: "{{count}} Ergebnis(se) für \"{{query}}\"",
    searchDocumentsNoResults: "Keine Ergebnisse für \"{{query}}\"",
    filterDocumentStatus: "Dokumentstatus",
    filterDocumentDateFrom: "Dokumentdatum von",
    filterDocumentDateTo: "Dokumentdatum bis",
    filterUploadDateFrom: "Upload-Datum von",
    filterUploadDateTo: "Upload-Datum bis",
    statementToValidate: "Auszug zu validieren",
    draftMode: "Entwurfsmodus",
    confirmImport: "Import bestätigen",
    extractedByVision: "Extrahiert durch Bildanalyse",
    extractedByText: "Extrahiert durch Text",
    reconciliationGapWarning: "Abweichung von {gap} — Zeilen prüfen",
    confirmUnbalancedTitle: "Unausgeglichener Auszug",
    confirmUnbalancedText: "Der Auszug ist nicht ausgeglichen. Trotzdem bestätigen?",
    ocrStatus: "OCR-Status",
    uploadedAt: "Hochgeladen am",
    pageXofN: "Seite {page} von {pages}",
    filterByStatus: "Nach Status filtern",
    allStatuses: "Alle",
    statusNew: "Neu",
    statusAssigned: "Zugewiesen",
    statusPartiallyProcessed: "Teilweise verarbeitet",
    statusProcessed: "Verarbeitet",
    createFullInvoice: "Vollständige Rechnung",
    depositInvoice: "Anzahlungsrechnung",
    partialInvoice: "Teilrechnung",
    depositAmount: "Anzahlungsbetrag",
    depositDescription: "Beschreibung",
    quantityToInvoice: "Zu fakturierende Menge",
    remainingQuantity: "Verbleibend",
    invoicedQuantity: "Fakturiert",
    totalQuantity: "Gesamt",
    notInvoiced: "Nicht fakturiert",
    partiallyInvoiced: "Teilweise fakturiert",
    fullyInvoiced: "Vollständig fakturiert",
    invoicingStatus: "Fakturierungsstatus",
    invoicedAmountOf: "fakturiert von",
    linkedInvoices: "Verknüpfte Rechnungen",
    noInvoicesYet: "Noch keine Rechnungen",
    youWantToCreateDepositInvoice: "Möchten Sie eine Anzahlungsrechnung erstellen?",
    youWantToCreatePartialInvoice: "Möchten Sie eine Teilrechnung erstellen?",
    noLinesToInvoice: "Keine Zeilen zum Fakturieren",
    depositAmountExceedsRemaining: "Der Betrag übersteigt den Restbetrag",
    manageStock: "Bestand verwalten",
    stockManagedDescription: "Jeder Verkauf wird den Bestand des Lagerzentrums automatisch verringern.",
    stockDisabledDescription: "Für Verkäufe dieser Kasse werden keine Bestandsbewegungen erzeugt.",
    stockManaged: "Bestand verwaltet",
    withoutStockManagement: "Ohne Bestandsverwaltung",
    recipient: "Empfänger",
    emailSubject: "Betreff",
    emailMessage: "Nachricht",
    emailSent: "E-Mail erfolgreich gesendet",
    emailDefaultMessage: "Anbei finden Sie das im Betreff genannte Dokument.",
    correctAccounts: "Konten korrigieren",
    saveCorrection: "Korrektur speichern",
    correctingAccountsDescription: "Sie können die Gegenkonten dieses Dokuments korrigieren. Die Buchung wird vor Ort aktualisiert.",
    successfullyCorrectedAccounts: "Konten erfolgreich korrigiert",

    // Payroll
    payroll: "Lohnbuchhaltung",
    payrollShort: "Löhne",
    employees: "Arbeitnehmer",
    addEmployee: "Arbeitnehmer hinzufügen",
    editEmployee: "Arbeitnehmer bearbeiten",
    employeeNumber: "Arbeitnehmernummer",
    searchEmployee: "Arbeitnehmer suchen...",
    noEmployeesFound: "Keine Arbeitnehmer gefunden",
    employeeStatusActive: "Aktiv",
    employeeStatusDraft: "Entwurf",
    employeeStatusTerminated: "Beendet",
    workCanton: "Arbeitskanton",
    activityRate: "Beschäftigungsgrad",
    employmentContract: "Arbeitsvertrag",
    avsNumber: "AHV-Nummer",
    residencePermit: "Aufenthaltsbewilligung",
    backToList: "Zurück zur Liste",
    backToDashboard: "Zurück zum Dashboard",
    featureComingSoon: "Diese Funktion wird bald verfügbar sein.",
    payrollAccessDenied: "Zugriff verweigert",
    payrollAccessDeniedOwnerOnly: "Die Lohnbuchhaltung ist dem Firmeninhaber vorbehalten. Kontaktieren Sie Ihren Administrator, wenn Sie Zugang haben sollten.",
    payrollAccessDeniedReconnect: "Falls Ihre Berechtigungen kürzlich aktualisiert wurden, melden Sie sich bitte ab und erneut an, um Ihre Sitzung zu aktualisieren.",

    // Payroll forms
    identity: "Identität",
    birthDate: "Geburtsdatum",
    gender: "Geschlecht",
    gender_male: "Männlich",
    gender_female: "Weiblich",
    civilStatus: "Zivilstand",
    civilStatus_single: "Ledig",
    civilStatus_married: "Verheiratet",
    civilStatus_divorced: "Geschieden",
    civilStatus_widowed: "Verwitwet",
    civilStatus_registered_partnership: "Eingetragene Partnerschaft",
    civilStatus_dissolved_partnership: "Aufgelöste Partnerschaft",
    civilStatusSince: "Zivilstand seit",
    civilStatusSinceHelp: "Bestimmt den anwendbaren Quellensteuer-Tarif. Eine Änderung des Zivilstands wird im Monat nach dem Ereignis wirksam.",
    nationality: "Nationalität",
    permitType: "Bewilligungsart",
    permitNumber: "Bewilligungsnummer",
    permitValidUntil: "Gültig bis",
    issuingCanton: "Ausstellungskanton",
    swissNational: "Schweizer Staatsangehöriger",
    permit: "Bewilligung",
    residence: "Wohnsitz",
    canton: "Kanton",
    municipality: "Gemeinde",
    familySituation: "Familiensituation",
    hasSpouse: "Hat Ehepartner / eingetragenen Partner",
    spouseIsWorking: "Ehepartner ist erwerbstätig",
    spouseWorkCanton: "Arbeitskanton des Ehepartners",
    spouseWorkCountry: "Arbeitsland des Ehepartners",
    children: "Kinder",
    addChild: "Kind hinzufügen",
    child: "Kind",
    allowanceFrom: "Zulage von",
    allowanceTo: "Zulage bis",
    inEducation: "In Ausbildung",
    paymentDetails: "Zahlungsdetails",
    bic: "BIC/SWIFT",
    accountHolder: "Kontoinhaber",
    notes: "Notizen",
    linkedContact: "Verknüpfter Kontakt",
    searchContact: "Bestehenden Kontakt suchen...",
    contactRequired: "Bitte wählen Sie einen Kontakt",
    refreshSnapshot: "Kontaktdaten aktualisieren",
    change: "Ändern",

    // Contract form
    contractHistory: "Vertragshistorie",
    addContractVersion: "Vertragsversion hinzufügen",
    newContractVersion: "Neue Vertragsversion",
    editContract: "Vertrag bearbeiten",
    newVersionWarning: "Es wird Version {version} des Vertrags erstellt, gültig ab dem von Ihnen festgelegten Datum. Version {prevVersion} wird automatisch geschlossen.",
    contractType: "Vertragsart",
    contractType_permanent: "Unbefristet",
    contractType_fixed_term: "Befristet",
    contractType_apprenticeship: "Lehre",
    contractType_internship: "Praktikum",
    salaryMode: "Lohnart",
    salaryMode_monthly: "Monatlich",
    salaryMode_hourly: "Stündlich",
    hireDate: "Eintrittsdatum",
    endReason: "Beendigungsgrund",
    weeklyHours: "Wochenstunden",
    probationMonths: "Probezeit (Monate)",
    noticePeriod: "Kündigungsfrist (Monate)",
    salary: "Gehalt",
    baseSalary: "Grundgehalt",
    thirteenthSalary: "13. Monatsgehalt",
    thirteenthMode: "Auszahlungsmodus",
    thirteenthMode_december: "Dezember",
    thirteenthMode_monthly_provision: "Monatliche Rückstellung",
    thirteenthModeHelp: "Auszahlung im Dezember — der 13. Monatslohn wird vollständig im Dezember ausbezahlt. Bei Austritt während des Jahres wird der anteilige Betrag in der Schlussabrechnung ausbezahlt.\n\nMonatliche Rückstellung — ein Zwölftel wird monatlich mit der laufenden Lohnabrechnung ausbezahlt. Keine Auszahlung im Dezember.",
    vacation: "Ferien",
    vacationDays: "Tage pro Jahr",
    vacationRate: "Ferienzuschlag (%)",
    workplace: "Arbeitsort",
    workplaceAddressCompany: "Firmenadresse",
    workplaceAddressOther: "Andere Adresse",
    validFrom: "Gültig ab",
    validTo: "Bis",
    version: "Version",
    current: "Aktuell",
    closed: "Geschlossen",
    future: "Zukünftig",
    noContracts: "Noch keine Verträge",
    // Contract termination
    terminateContract: "Vertrag kündigen",
    confirmTermination: "Kündigung bestätigen",
    terminationConsequences: "Die Kündigung des Vertrags hat folgende Auswirkungen:",
    terminationStatusChange: "Der Mitarbeiterstatus ändert sich auf <strong>gekündigt</strong>",
    terminationFinalSettlement: "Eine <strong>Schlussabrechnung</strong> wird in der Lohnperiode erstellt, die dieses Datum enthält",
    terminationExclusion: "Der Mitarbeiter wird <strong>von nachfolgenden Lohnabrechnungen ausgeschlossen</strong>, ausser für rückwirkende Anpassungen",
    terminationWarning: "Die Kündigung eines Vertrags löst eine Schlussabrechnung in der Lohnperiode aus, die das Austrittsdatum enthält. Diese Aktion kann vor der Validierung der Lohnabrechnung rückgängig gemacht werden.",
    contractTerminated: "Vertrag gekündigt",
    cancelTermination: "Kündigung aufheben",
    cancelTerminationConfirm: "Sind Sie sicher, dass Sie diese Kündigung aufheben möchten? Der Mitarbeiter wird wieder auf den aktiven Status gesetzt.",
    terminationCancelled: "Kündigung aufgehoben",
    terminated: "Gekündigt",
    endReason_resignation: "Kündigung durch Arbeitnehmer",
    endReason_dismissal: "Kündigung durch Arbeitgeber",
    endReason_mutual_agreement: "Aufhebungsvereinbarung",
    endReason_end_of_term: "Ablauf der Befristung",
    endReason_retirement: "Pensionierung",
    endReason_death: "Tod",
    endReason_disability: "Invalidität",
    endReason_probation: "Ende der Probezeit",

    // Payroll — Company salary settings
    salarySettings: "Lohneinstellungen",
    insurancePlans: "Versicherungspläne",
    payrollSettings: "Lohnabrechnungseinstellungen",
    payrollCompleteness: "Bereitschaftsstatus",
    payrollCompletenessOk: "Alle erforderlichen Einstellungen sind konfiguriert. Die Lohnabrechnung kann berechnet werden.",
    payrollCompletenessMissing: "Folgende Einstellungen müssen abgeschlossen werden, bevor die Lohnabrechnung berechnet werden kann:",
    insurancePlanType_laap: "UVG Berufsunfall (UVGB)",
    insurancePlanType_laanp: "UVG Nichtberufsunfall (UVGNB)",
    insurancePlanType_laac: "UVG Zusatzversicherung (UVGZ)",
    insurancePlanType_ijm: "Krankentaggeldversicherung (KTG)",
    insurancePlanType_lpp: "Berufliche Vorsorge (BVG)",
    insurerName: "Name des Versicherers",
    policyNumber: "Policennummer",
    rateEmployee: "Arbeitnehmerbeitrag (%)",
    rateEmployer: "Arbeitgeberbeitrag (%)",
    riskClass: "Risikoklasse",
    lppRatesByAge: "Beitragssätze nach Alterskategorie",
    lppAgeFrom: "Von Alter",
    lppAgeTo: "Bis Alter",
    addAgeBracket: "Alterskategorie hinzufügen",
    coordinationDeductionOverride: "Koordinationsabzug (Überschreibung)",
    entryThresholdOverride: "Eintrittsschwelle (Überschreibung)",
    addInsurancePlan: "Versicherungsplan hinzufügen",
    editInsurancePlan: "Versicherungsplan bearbeiten",
    noInsurancePlans: "Noch keine Versicherungspläne",
    effectiveSince: "In Kraft seit {date}",
    closurePlanWarning: "Dieser Plan wird am {date} in Kraft treten. Der aktuelle {type}-Plan wird am {closureDate} geschlossen.",
    confirmDeletePlan: "Möchten Sie diesen Versicherungsplan wirklich löschen?",
    deletePlan: "Plan löschen",
    avsFund: "AHV-Ausgleichskasse",
    avsFundName: "Name der Kasse",
    avsMemberNumber: "Mitgliedsnummer",
    avsAdministrationRate: "Verwaltungskostenbeitrag (%)",
    familyAllowanceFund: "Familienausgleichskasse",
    familyAllowanceFundName: "Name der Kasse",
    familyAllowanceMemberNumber: "Mitgliedsnummer",
    withholdingTax: "Quellensteuer",
    withholdingTaxCanton: "Steuerkanton",
    withholdingTaxDebtorNumber: "Schuldnernummer",
    withholdingTaxPeriodicity: "Deklarationsperiodizität",
    periodicityMonthly: "Monatlich",
    periodicityQuarterly: "Quartalsweise",
    periodicityAnnual: "Jährlich",
    payFrequency: "Lohnauszahlungsrhythmus",
    payFrequencyMonthly: "Monatlich",
    payFrequencySemiMonthly: "Halbmonatlich",
    payFrequencyWeekly: "Wöchentlich",
    missingActiveLaap: "Aktiver UVGB-Plan mit Arbeitgeberbeitrag",
    missingActiveLaanp: "Aktiver UVGNB-Plan mit Arbeitnehmerbeitrag",
    missingActiveLpp: "Aktiver BVG-Plan mit Alterskategorien",
    missingAvsFundName: "Name der AHV-Ausgleichskasse",
    missingAvsAdminRate: "AHV-Verwaltungskostenbeitrag",
    missingFamilyAllowanceFundName: "Name der Familienausgleichskasse",
    missingAvsAdminBase: "Berechnungsgrundlage der AHV-Verwaltungskosten",
    missingFamilyAllowanceRate: "Beitragssatz Familienzulagen",
    administrationBase: "Berechnungsgrundlage Verwaltungskosten",
    administrationBaseAvsContributions: "AHV/IV/EO-Beiträge",
    administrationBaseGrossAvs: "AHV-pflichtiger Bruttolohn",
    administrationBaseHelp: "Je nach Ausgleichskasse wird der Satz entweder auf die AHV/IV/EO-Beiträge oder auf den AHV-pflichtigen Bruttolohn angewendet. Diese Angabe finden Sie auf Ihrer Kassenabrechnung.",
    familyAllowanceContributionRate: "Arbeitgeberbeitragssatz",
    familyAllowanceRateHelp: "Dieser Satz hängt von der Familienausgleichskasse ab, nicht vom Kanton. Zwei Unternehmen im selben Kanton mit verschiedenen Kassen zahlen unterschiedliche Sätze.",
    expenseRegulation: "Spesenreglement",
    expenseRegulationApproved: "Genehmigtes Spesenreglement",
    expenseRegulationCanton: "Genehmigungskanton",
    expenseRegulationDate: "Genehmigungsdatum",
    expenseRegulationReference: "Referenznummer",
    withholdingTaxNote: "Die Quellensteuer-Konfiguration ist unvollständig. Volle Unterstützung (Tarifabfrage, Jahresabrechnung) ist für eine zukünftige Version geplant.",
    showPlanHistory: "Verlauf anzeigen",
    hidePlanHistory: "Verlauf ausblenden",

    // Payroll — Payroll runs
    payrollRuns: "Lohnläufe",
    payrollRun: "Lohnlauf",
    payslip: "Lohnabrechnung",
    payslips: "Lohnabrechnungen",
    openPeriod: "Periode eröffnen",
    period: "Periode",
    employeeCount: "Mitarbeiter",
    grossTotal: "Brutto",
    netTotal: "Netto",
    employerCost: "Arbeitgeberkosten",
    totalDeductions: "Abzüge",
    totalEmployerCharges: "Arbeitgeberbeiträge",
    validatedAt: "Validiert am",
    calculate: "Berechnen",
    recalculate: "Neu berechnen",
    validate: "Validieren",
    markAsPaid: "Als bezahlt markieren",
    cancelRun: "Stornieren",
    regeneratePdfs: "PDFs regenerieren",
    downloadSummary: "Zusammenfassung herunterladen",
    downloadPayslip: "Lohnabrechnung herunterladen",
    calculating: "Berechnung läuft...",
    calculatingProgress: "Berechnung läuft. Dies kann einige Minuten dauern.",
    calculatingTimeout: "Die Berechnung dauert länger als erwartet. Sie können es erneut versuchen.",
    retryCalculation: "Berechnung wiederholen",
    noPayrollRuns: "Keine Lohnläufe vorhanden",
    noPayslips: "Keine Lohnabrechnungen",
    createPayrollRun: "Lohnperiode eröffnen",
    periodAlreadyExists: "Für diese Periode existiert bereits ein Lohnlauf.",
    periodAlreadyExistsLink: "Bestehenden Lohnlauf anzeigen",
    confirmValidateTitle: "Lohnlauf validieren",
    confirmValidateBody: "{count} Abrechnungen — Brutto: {gross} — Netto: {net} — Arbeitgeberkosten: {employerCost}",
    confirmValidateIrreversible: "Diese Aktion ist unwiderruflich. Die Abrechnungen werden eingefroren und die PDFs erstellt. Korrekturen erfolgen über eine Stornierung oder eine rückwirkende Anpassung.",
    confirmValidateFinalSettlements: "Dieser Lohnlauf enthält {count} Endabrechnung(en).",
    confirmValidateNegativeNets: "Dieser Lohnlauf enthält {count} Abrechnung(en) mit negativem Nettobetrag.",
    confirmCancelTitle: "Lohnlauf stornieren",
    cancellationReason: "Stornierungsgrund",
    cancellationReasonRequired: "Ein Grund ist erforderlich, um einen Lohnlauf zu stornieren.",
    confirmPayTitle: "Als bezahlt markieren",
    confirmPayBody: "Bestätigen Sie, dass {count} Abrechnungen mit einem Nettobetrag von {net} bezahlt wurden.",
    payslipProvisional: "Vorläufig — noch nicht validiert",
    provisional: "Provisorisch",
    interim: "Zwischenabschluss",
    ancillaryActivities: "Nebenbetriebliche Tätigkeiten",
    extraordinaryItems: "Ausserbetrieblich und ausserordentlich",
    payslipFailed: "Berechnung fehlgeschlagen",
    controlPanel: "Kontrollpanel",
    failedPayslips: "Fehlgeschlagene Abrechnungen",
    failedPayslipsBlocking: "Validierung blockiert: {count} Abrechnung(en) fehlgeschlagen.",
    excludedEmployees: "Ausgeschlossene Mitarbeiter",
    runWarnings: "Warnungen",
    finalSettlements: "Endabrechnungen",
    negativeNets: "Negative Nettobeträge",
    retroactiveOnly: "Nur Rückwirkende",
    runStatusDraft: "Entwurf",
    runStatusCalculating: "Berechnung läuft",
    runStatusCalculated: "Berechnet",
    runStatusValidated: "Validiert",
    runStatusPaid: "Bezahlt",
    runStatusCancelled: "Storniert",
    exclusionStatusDraft: "Mitarbeiter im Entwurfsstatus",
    exclusionStatusTerminated: "Arbeitsverhältnis beendet",
    exclusionNoContract: "Kein aktiver Vertrag",
    exclusionHireAfterPeriod: "Nach der Periode eingestellt",
    exclusionContractEndedBeforePeriod: "Vertrag vor der Periode beendet",
    warningLppNotVerifiableHourly: "BVG-Beiträge konnten für Stundenlöhner nicht überprüft werden",
    warningPdfGenerationFailed: "PDF-Erstellung für diese Abrechnung fehlgeschlagen",
    warningHasAbsence: "Dieser Mitarbeiter hat Abwesenheiten in der Periode",
    warningHourlyAbsenceNotDeducted: "Stundenlöhner mit Abwesenheiten — Abzug wird nicht automatisch angewendet",
    warningHourlyZeroGross: "Stundenlöhner mit Bruttolohn null",

    // Monthly declaration
    monthlyDeclaration: "Monatsmeldung",
    monthlyDeclarations: "Monatsmeldungen",
    socialInsuranceDays: "SV-Tage",
    absenceDays: "Abwesenheitstage",
    effectiveWorkingDays: "Effektive Arbeitstage",
    workingHours: "Stunden",
    absences: "Abwesenheiten",
    addAbsence: "Abwesenheit hinzufügen",
    editAbsence: "Abwesenheit bearbeiten",
    deleteAbsence: "Abwesenheit löschen",
    absenceOngoing: "Laufend",
    daysRetained: "{days} Tag(e) berücksichtigt",
    declarationValidated: "Validiert",
    declarationDraft: "Entwurf",
    validateDeclaration: "Meldung validieren",
    validateAllDeclarations: "Alle validieren",
    saveDeclaration: "Speichern",
    noEligibleEmployees: "Keine berechtigten Mitarbeiter für diesen Zyklus",
    hourlyNoHoursWarning: "Stundenlöhner ohne eingetragene Stunden — Abrechnung wird null sein",
    declarationNotValidated: "Meldung nicht validiert",
    recalculationNeeded: "Die Lohnvariablen wurden seit der letzten Berechnung geändert. Eine Neuberechnung ist vor der Validierung erforderlich.",
    loadError: "Fehler beim Laden der Daten",
    retry: "Erneut versuchen",
    punctualRubriques: "Einmalige Positionen",
    addRubrique: "Position hinzufügen",
    removeRubrique: "Entfernen",
    rubriqueCode: "Code",
    rubriqueLabel: "Bezeichnung",
    rubriqueAmount: "Betrag",
    rubriqueQuantity: "Menge",
    rubriqueRate: "Satz",
    rubriqueCalculationMode: "Berechnungsmodus",
    declarationFor: "Deklaration von {name}",
    backToRun: "Zurück zum Zyklus",
    editDeclaration: "Variablen erfassen",
    activityRate: "Beschäftigungsgrad",
    noRubriques: "Keine einmaligen Rubriken",
    saveAndClose: "Speichern und schliessen",

    // Absence reasons
    absenceReason: "Abwesenheitsgrund",
    absenceReasonIllness: "Krankheit",
    absenceReasonAccidentOccupational: "Berufsunfall",
    absenceReasonAccidentNonOccupational: "Nichtberufsunfall",
    absenceReasonMilitaryService: "Militärdienst",
    absenceReasonMaternity: "Mutterschaft",
    absenceReasonPaternity: "Vaterschaft",
    absenceReasonUnpaid: "Unbezahlte Abwesenheit",
    absenceReasonUnjustified: "Unentschuldigte Abwesenheit",
    incapacityRate: "Arbeitsunfähigkeitsgrad",
    salaryContinuationRate: "Lohnfortzahlung",
    absenceFrom: "Von",
    absenceTo: "Bis",
    absenceToHelp: "Leer lassen wenn die Abwesenheit noch andauert",
    confirmDeleteAbsence: "Sind Sie sicher, dass Sie diese Abwesenheit löschen möchten?",

    // Absence report
    absenceReport: "Abwesenheitsbericht",
    absenceHistory: "Abwesenheitshistorie",
    totalByReason: "Total nach Grund",
    noAbsences: "Keine Abwesenheiten",
    filterByYear: "Nach Jahr filtern",
    filterByReason: "Nach Grund filtern",
    allReasons: "Alle Gründe",
    goToPayrollRun: "Lohnlauf anzeigen",
    companySnapshotIncomplete: "Firmendaten unvollständig (Name, Adresse oder IDE-Nummer fehlt). Lohnabrechnungs-PDFs könnten betroffen sein.",
    companySettings: "Zu den Firmeneinstellungen",
    validateBlockedByFailures: "Validierung nicht möglich: Es gibt fehlgeschlagene Abrechnungen",
    backToPayrollRuns: "Zurück zu den Lohnläufen",
    year: "Jahr",

    // Zod error map
    zodFieldRequired: "Dieses Feld ist erforderlich",
    zodInvalidType: "Ungültiger Wert",
    zodTooShort: "Mindestens {min} Zeichen",
    zodTooLong: "Höchstens {max} Zeichen",
    zodNumberTooSmall: "Muss mindestens {min} sein",
    zodNumberTooBig: "Darf höchstens {max} sein",
    zodArrayTooShort: "Mindestens {min} Element(e) erforderlich",
    zodInvalidEmail: "Ungültige E-Mail-Adresse",
    zodInvalidFormat: "Ungültiges Format",
    zodInvalidSelection: "Bitte wählen Sie eine gültige Option",
    zodInvalidDate: "Ungültiges Datum",
    zodInvalidValue: "Ungültiger Wert",

    // Reconciliation indicators
    reconciled: "Abgestimmt",
    notReconciled: "Nicht abgestimmt",
    filteredTotalsWarning: "Die Summen entsprechen dem aktiven Filter, nicht dem gesamten Konto",

    // Recurring contracts
    recurringContracts: "Wiederkehrende Verträge",
    recurringContract: "Wiederkehrender Vertrag",
    addRecurringContract: "Wiederkehrenden Vertrag hinzufügen",
    createRecurringContract: "Wiederkehrenden Vertrag erstellen",
    updateRecurringContract: "Wiederkehrenden Vertrag bearbeiten",
    viewRecurringContract: "Vertragsdetails",
    searchRecurringContract: "Vertrag suchen...",
    allStatuses: "Alle Status",
    frequency: "Häufigkeit",
    monthly: "Monatlich",
    quarterly: "Vierteljährlich",
    semiAnnual: "Halbjährlich",
    annual: "Jährlich",
    nextInvoiceDate: "Nächste Rechnung",
    generateInvoice: "Rechnung generieren",
    generateInvoiceConfirm: "Eine Rechnung wird aus diesem Vertrag erstellt.",
    invoiceGenerated: "Rechnung generiert",
    generatedInvoices: "Generierte Rechnungen",
    pause: "Pausieren",
    paused: "Pausiert",
    activate: "Aktivieren",
    changeStatusTo: "Status ändern zu",
    ended: "Beendet",
    every: "Alle",
    quarters: "Quartale",
    anchorDay: "Tag des Monats",
    issueOffsetDays: "Vorlauf Erstellung (Tage)",
    autoValidate: "Automatisch validieren",
    autoSend: "Automatisch senden",
    autoBilling: "Automatische Rechnungsstellung (validieren und senden)",
    autoBillingRequiresAccount: "Der ausgewählte Service hat kein Buchhaltungskonto konfiguriert; die automatische Rechnungsstellung erfordert ein Konto.",
    autoRenew: "Automatische Verlängerung",
    autoRenewHint: "Vertrag automatisch bei Ablauf verlängern",
    renewDaysBefore: "Tage vor Ablauf verlängern",
    renewDaysBeforeHint: "Anzahl Tage vor Ablauf zur Auslösung der automatischen Verlängerung",
    renewNow: "Jetzt verlängern",
    renewConfirm: "Der Vertrag wird um eine weitere Periode verlängert.",
    contractRenewed: "Vertrag verlängert",
    lifecycleHistory: "Lebenszyklus-Verlauf",
    eventRenewed: "Verlängert",
    eventEnded: "Beendet",
    triggerAuto: "Automatisch",
    triggerManual: "Manuell",
    noLifecycleEvents: "Keine Ereignisse",
    renewalCount: "Verlängerungen",
    paymentTermsDays: "Zahlungsfrist (Tage)",

    // Bank statement extraction retry
    retryExtraction: "Extraktion erneut starten",
    extractionFailedRetry: "Extraktion fehlgeschlagen. Sie können es erneut versuchen.",
    extractionEmptyRetry: "Extraktion abgeschlossen, aber keine Zeilen gefunden. Sie können es erneut versuchen.",
    extractionInProgress: "Extraktion läuft…",
    retrying: "Wird erneut versucht…",

    // Dunning policies
    dunningPolicies: "Mahnrichtlinien",
    dunningLabelRequired: "Name der Richtlinie ist erforderlich",
    dunningStepsRequired: "Mindestens ein Schritt ist erforderlich",
    editDunningPolicy: "Mahnrichtlinie bearbeiten",
    addDunningPolicy: "Mahnrichtlinie hinzufügen",
    appliesTo: "Gilt für",
    both: "Beide",
    setAsDefault: "Standardrichtlinie",
    stopAfterLastStep: "Nach dem letzten Schritt stoppen",
    dunningSteps: "Mahnstufen",
    addStep: "Schritt hinzufügen",
    step: "Schritt",
    offsetDays: "Versatz (Tage ab Fälligkeit)",
    offsetDaysHint: "Negativ = vor Fälligkeit (Höflichkeitserinnerung)",
    channel: "Kanal",
    escalationTone: "Ton",
    templateKey: "Vorlagenschlüssel",
    toneNeutral: "Neutral",
    toneFirm: "Bestimmt",
    toneFormal: "Formell",
    addLateFee: "Mahngebühren hinzufügen",
    lateFeeType: "Gebührenart",
    lateFeeFixed: "Pauschalgebühr",
    lateFeeInterest: "Verzugszins",
    lateFeeBoth: "Pauschale + Zins",
    lateFeeLabel: "Bezeichnung auf Rechnung",
    fixedAmount: "Pauschalbetrag",
    annualRate: "Jahreszins (%)",
    interestBase: "Berechnungsbasis",
    basePrincipal: "Hauptforderung",
    baseCurrent: "Aktueller Betrag",
    dunningPolicy: "Mahnrichtlinie",
    noDunning: "Kein Mahnwesen",
    dunningPolicyHint: "Mahnrichtlinie für dieses Dokument auswählen",
    dunningConfigured: "Konfiguriert",
    dunningRelances: "Mahnungen",
    dunningActive: "Aktiv",
    dunningSuspended: "Ausgesetzt",
    dunningStopped: "Gestoppt",
    dunningUntil: "bis",
    lateFee: "Gebühren",
    noDunningSent: "Noch keine Mahnung gesendet.",
    suspendDunning: "Mahnungen aussetzen?",
    resumeDunning: "Fortsetzen",
    stopDunning: "Mahnungen endgültig stoppen?",
    yesStop: "Ja, stoppen",
    dunningWillPause: "Die automatischen Mahnungen werden für diese Rechnung pausiert.",
    dunningStopIrreversible: "Diese Rechnung wird nie wieder automatisch gemahnt.",
    dunningResumed: "Mahnungen fortgesetzt",

    // Subscription banner
    subscriptionTrialBanner: "Ihre kostenlose Testphase endet am {date} (noch {days} Tage)",
    subscriptionPastDueBanner: "Ihre Rechnung ist unbezahlt. Bitte begleichen Sie diese vor dem {date}, um eine Dienstunterbrechung zu vermeiden",
    subscriptionExpiredBanner: "Ihr Abonnement ist abgelaufen. Der Zugriff ist schreibgeschützt. Bitte erneuern Sie, um den vollen Zugriff wiederherzustellen",
    subscriptionCancelledBanner: "Ihr Abonnement endet am {date}",
    subscriptionDaysRemaining: "noch {days} Tage",
    subscriptionPayNow: "Jetzt bezahlen",
    subscriptionChoosePlan: "Angebot wählen",

    // Subscription & plan labels
    subscription: "Abonnement",
    featureNotIncluded: "Nicht in Ihrem aktuellen Plan enthalten",
    featureRequiresPlan: "Verfügbar ab dem {plan}-Plan",
    featureRequiresActiveSubscription: "Ein aktives Abonnement ist erforderlich",
    featureViewOffers: "Angebote ansehen",
    featureRegularize: "Abonnement erneuern",
    featureContactAdmin: "Wenden Sie sich an Ihren Administrator, um ein Upgrade durchzuführen",

    // Subscription management (F2)
    subscriptionMySubscription: "Mein Abonnement",
    subscriptionOffers: "Angebote & Preise",
    subscriptionCurrentPlan: "Aktuelles Angebot",
    subscriptionFreePlan: "Kostenlos",
    subscriptionBillingCycle: "Abrechnungszyklus",
    subscriptionNextRenewal: "Nächste Verlängerung",
    subscriptionTrialEndsOn: "Testphase endet am {date}",
    subscriptionTrialDaysLeft: "Noch {days} Tage in Ihrer Testphase",
    subscriptionPendingChange: "Ausstehende Änderung",
    subscriptionPendingChangeDetail: "Sie wechseln am {date} zu {plan}",
    subscriptionCancelPendingChange: "Änderung abbrechen",
    subscriptionPendingChangeCancelled: "Ausstehende Änderung abgebrochen",
    subscriptionCancelPendingConfirmTitle: "Planänderung abbrechen?",
    subscriptionCancelPendingConfirmText: "Ihr Abonnement bleibt beim Plan {currentPlan}. Der Wechsel zu {pendingPlan} findet nicht statt.",
    subscriptionQuotas: "Nutzung & Kontingente",
    subscriptionQuotaUsage: "{current} / {limit}",
    subscriptionUnlimited: "Unbegrenzt",
    subscriptionChangePlan: "Angebot wechseln",
    subscriptionChooseMyOffer: "Mein Angebot wählen",
    subscriptionPayMyInvoice: "Meine Rechnung bezahlen",
    subscriptionAnnualSavingsHint: "Sparen Sie {percent} % mit jährlicher Abrechnung",
    subscriptionCancelSubscription: "Abonnement kündigen",
    subscriptionReactivate: "Reaktivieren",
    subscriptionCancelConfirmTitle: "Abonnement kündigen?",
    subscriptionCancelConfirmText: "Sie behalten den Zugang bis zum Ende des aktuellen Zeitraums. Danach wird Ihr Abonnement nicht verlängert.",
    subscriptionCancelledSuccess: "Ihr Abonnement wurde gekündigt",
    subscriptionReactivatedSuccess: "Ihr Abonnement wurde reaktiviert",
    subscriptionUpgrade: "Upgrade",
    subscriptionDowngrade: "Downgrade",
    subscriptionUpgradeConfirmTitle: "Zu {plan} wechseln?",
    subscriptionUpgradeConfirmText: "Diese Änderung tritt sofort in Kraft. Ihnen wird der anteilige Betrag berechnet.",
    subscriptionDowngradeConfirmTitle: "Zu {plan} wechseln?",
    subscriptionDowngradeConfirmText: "Ihr Angebot wechselt am {date} zu {plan}. Bis dahin behalten Sie alle aktuellen Funktionen.",
    subscriptionChangeSuccess: "Ihr Angebot wurde aktualisiert",
    subscriptionEffectImmediate: "Sofort wirksam",
    subscriptionEffectAtDate: "Wirksam ab {date}",
    subscriptionYouWillBeCharged: "Zu berechnender Betrag: {amount}",
    subscriptionProrataNotice: "Ihnen wird der anteilige Betrag berechnet",
    subscriptionCompareOffers: "Angebote vergleichen",
    subscriptionYourCurrentPlan: "Ihr Angebot",
    subscriptionSelectPlan: "Auswählen",
    subscriptionIncluded: "Enthalten",
    subscriptionOptionalAddon: "Optional",
    subscriptionNotIncluded: "Nicht enthalten",
    subscriptionCatalogUnavailable: "Angebote sind vorübergehend nicht verfügbar. Bitte versuchen Sie es später erneut.",
    subscriptionNoPricingForCycle: "Für diesen Abrechnungszyklus nicht verfügbar",
    subscriptionNoPlan: "Kein aktives Angebot",
    subscriptionStatusActive: "Aktiv",
    subscriptionStatusTrial: "Testphase",
    subscriptionStatusPastDue: "Überfällig",
    subscriptionStatusExpired: "Abgelaufen",
    subscriptionStatusCancelled: "Gekündigt",
    subscriptionPerMonth: "/Monat",
    subscriptionPerYear: "/Jahr",
    subscriptionEquivPerMonth: "/Mt.",
    subscriptionBilledPerYear: "{amount}/Jahr abgerechnet",
    subscriptionSavingsPercent: "{percent} % sparen",
    featureComingSoon: "Demnächst verfügbar",

    // Upgrade modal (F6)
    subscriptionUpgradePlan: "Plan wechseln",
    subscriptionWhatsInPlan: "Was ist im Plan {plan} enthalten?",
    subscriptionRecommended: "Empfohlen",
    subscriptionFeatureRequiresUpgrade: "Die Funktion {feature} erfordert ein Plan-Upgrade.",
    payrollAccessDeniedPlanRequired: "Das Lohnmodul ist in Ihrem aktuellen Plan nicht enthalten. Wechseln Sie zu einem höheren Plan.",
    subscriptionModalTitleChoose: "Wählen Sie Ihren Plan",
    subscriptionModalTitleChange: "Plan wechseln",
    subscriptionSubscribeAction: "Abonnieren",
    subscriptionSwitchTo: "Zu {plan} wechseln",
    subscriptionDowngradeTo: "Auf {plan} herabstufen",
    subscriptionFeaturesAdded: "Enthaltene Funktionen",
    subscriptionFeaturesRemoved: "Nicht enthaltene Funktionen",
    subscriptionSeeAllFeatures: "Alle Funktionen anzeigen",
    subscriptionHideFeatures: "Funktionen ausblenden",

    // First-choice flow (Lot 4)
    subscriptionChooseTitle: "Wählen Sie Ihren Plan",
    subscriptionChooseSubtitle: "Wählen Sie einen Plan und optionale Zusatzoptionen.",
    subscriptionChooseConfirmTitle: "Auswahl bestätigen",
    subscriptionChooseConfirmText: "Sie abonnieren den Plan {plan} ({cycle}).",
    subscriptionChooseSuccess: "Ihr Plan wurde aktiviert",
    subscriptionChooseWithAddons: "mit {count} Zusatzoption(en)",
    subscriptionPriceSummary: "Preisübersicht",
    subscriptionPlanPrice: "Plan ({plan})",
    subscriptionAddonsTotal: "Zusatzoptionen",
    subscriptionSubtotalHT: "Zwischensumme ohne MwSt.",
    subscriptionVatRate: "MwSt. ({rate} %)",
    subscriptionTotalTTC: "Gesamtbetrag inkl. MwSt.",
    subscriptionVatOnInvoiceNote: "Alle Preise verstehen sich ohne MwSt. Die MwSt. erscheint auf Ihrer Rechnung.",
    subscriptionConfirmChoice: "Bestätigen und abonnieren",
    subscriptionWizardStepPlan: "Plan",
    subscriptionWizardStepAddons: "Zusatzoptionen",
    subscriptionWizardStepSummary: "Zusammenfassung",
    subscriptionWizardNext: "Weiter",
    subscriptionWizardBack: "Zurück",
    subscriptionWizardConfirmAndPay: "Bestätigen und bezahlen",
    subscriptionAddonsLoading: "Verfügbare Zusatzoptionen werden geladen…",
    subscriptionAddonsLoadError: "Zusatzoptionen konnten nicht geladen werden. Bitte versuchen Sie es erneut.",
    subscriptionAddonsIncompatibleRemoved: "Einige Zusatzoptionen wurden entfernt, da sie mit dem ausgewählten Plan nicht kompatibel sind.",
    subscriptionTotalHT: "Gesamtbetrag ohne MwSt.",
    subscriptionChangeTitle: "Plan ändern",
    subscriptionChangeSubtitle: "Wählen Sie einen neuen Plan und optionale Zusatzoptionen.",
    subscriptionWizardConfirmChange: "Änderung bestätigen",
    subscriptionConfirmedWaiting: "Ihr Abonnement ist best\u00e4tigt. Wir bereiten Ihre Rechnung vor\u2026",
    subscriptionInvoiceReady: "Ihre Rechnung ist bereit.",
    subscriptionTimeoutMessage: "Ihr Abonnement ist best\u00e4tigt. Ihre Rechnung wird in K\u00fcrze auf dem Abonnement-Bildschirm verf\u00fcgbar sein.",
    subscriptionDownloadingPdf: "Wird heruntergeladen\u2026",
    subscriptionPlanDenied: "Dieser Plan ist für Ihr Konto nicht verfügbar.",
    subscriptionAddonBlocksChange: "Einige ausgewählte Zusatzoptionen sind mit diesem Plan nicht kompatibel. Bitte entfernen Sie diese zuerst.",
    subscriptionSelectAddons: "Optionale Zusatzoptionen",
    subscriptionNoAddonsSelected: "Keine Zusatzoptionen ausgewählt",
    subscriptionInvoiceNotice: "Eine Rechnung wird Ihnen {days} Tage vor Beginn des Abonnements zugestellt.",
    subscriptionTrialUnchanged: "Ihre kostenlose Testphase bleibt bis zum {date} aktiv.",
    subscriptionPaymentFlexible: "Jede Rechnung kann per QR-Rechnung oder Kreditkarte bezahlt werden — Sie entscheiden bei jeder Fälligkeit.",
    subscriptionTermsLink: "Allgemeine Geschäftsbedingungen",
    subscriptionRenewalNoticeMonthly: "Ihr Abonnement wird automatisch jeden Monat zum Preis von {amount} exkl. MwSt. verlängert, sofern es nicht vorher gekündigt wird.",
    subscriptionRenewalNoticeYearly: "Ihr Abonnement wird automatisch jedes Jahr zum Preis von {amount} exkl. MwSt. verlängert, sofern es nicht vorher gekündigt wird.",
    subscriptionCancellationNotice: "Sie können Ihr Abonnement jederzeit auf dieser Seite kündigen. Die Kündigung wird am Ende des laufenden Zeitraums wirksam — Sie behalten den Zugang bis zu diesem Datum.",

    // Trial-aware billing disclosures (Lot 3)
    subscriptionInvoiceIssuedNow: "Ihre Rechnung wird sofort erstellt, zahlbar bis zum {date}.",
    subscriptionTrialUpgradeNotice: "Neues Angebot ab sofort. Rechnung über die Differenz von {amount} exkl. MwSt., zahlbar bis zum {date}.",
    subscriptionTrialUpgradeOperatorNotice: "Ihre erste Rechnung wird zum Tarif von {plan} erstellt.",
    subscriptionTrialDowngradeNotice: "{plan} tritt ab dem {date} in Kraft. Ihre erste Periode bleibt bei {currentPlan}.",
    subscriptionCancelResiliation: "Kündigung widerrufen",
    subscriptionCancelResiliationConfirmText: "Ihr Abonnement läuft weiter und die Abrechnung wird fortgesetzt.",
    subscriptionErrorNothingToUndo: "Es liegt keine laufende Kündigung vor, die widerrufen werden kann.",
    subscriptionErrorPlanChoiceRequired: "Bitte wählen Sie zuerst ein Angebot, bevor Sie Änderungen vornehmen.",

    // Add-ons (F7 part C)
    addonSectionTitle: "Zusatzoptionen",
    addonAvailable: "Verfügbar",
    addonActive: "Aktiv",
    addonPendingCancellation: "Aktiv — Kündigung zum Periodenende",
    addonActivate: "Aktivieren",
    addonDeactivate: "Deaktivieren",
    addonActivateConfirmTitle: "{name} aktivieren?",
    addonActivateConfirmText: "Diese Option kostet {price} und die Abrechnung erfolgt sofort. Eine anteilige Rechnung wird umgehend erstellt. Dies ist keine kostenlose Testversion.",
    addonActivateConfirmTextTrial: "Diese Option ist bis zum Ende Ihrer Testphase am {date} kostenlos. Es wird jetzt keine Rechnung erstellt. Nach der Testphase wird sie mit {price} zusammen mit Ihrem Plan abgerechnet.",
    addonActivateConfirmButton: "Jetzt aktivieren",
    addonActivatedSuccess: "{name} ist jetzt aktiv",
    addonActivatedInvoiceNotice: "Die Funktion ist sofort verfügbar. Eine anteilige Rechnung folgt in Kürze.",
    addonActivatedInvoiceNoticeTrial: "Die Funktion ist sofort verfügbar, kostenlos bis zum {date}. Die Abrechnung beginnt mit Ihrem Plan.",
    addonDeactivateConfirmTitle: "{name} deaktivieren?",
    addonDeactivateConfirmText: "Die Option bleibt bis zum Ende der aktuellen Abrechnungsperiode ({date}) aktiv. Es erfolgt keine Rückerstattung — die Abrechnung endet zum Periodenende.",
    addonDeactivateConfirmButton: "Zum Periodenende deaktivieren",
    addonDeactivatedSuccess: "{name} wird zum Ende der aktuellen Periode deaktiviert",
    addonAlreadyActive: "Diese Option ist bereits aktiv",
    addonIncompatible: "Diese Option ist mit Ihrem aktuellen Plan nicht kompatibel",
    addonNoPermission: "Sie haben keine Berechtigung, Zusatzoptionen zu verwalten. Wenden Sie sich an Ihren Administrator.",
    addonActiveUntil: "Aktiv bis {date}",
    addonBillingCycleMonthly: "pro Monat",
    addonBillingCycleYearly: "pro Jahr",
    addonBillingCycleOneTime: "einmalig",
    addonNoneAvailable: "Keine Zusatzoptionen für Ihren aktuellen Plan verfügbar.",
    addonManageAddons: "Zusatzoptionen verwalten",

    // Gated nav items — disabled tab tooltips
    navFeatureRequiresUpgrade: "Ab einem höheren Angebot verfügbar",
    navFeatureAvailableAsAddon: "Als Option erhältlich",

    // Billing — invoices & payments (F3)
    billingInvoices: "Rechnungen",
    billingInvoiceNumber: "Nummer",
    billingInvoiceDate: "Datum",
    billingInvoiceDueDate: "Fälligkeitsdatum",
    billingInvoiceAmount: "Betrag",
    billingInvoiceStatus: "Status",
    billingInvoiceStatusOpen: "Offen",
    billingInvoiceStatusPaid: "Bezahlt",
    billingInvoiceStatusVoid: "Storniert",
    billingInvoiceStatusDraft: "Entwurf",
    billingInvoiceStatusUncollectible: "Uneinbringlich",
    billingInvoiceOverdue: "Überfällig",
    billingPay: "Bezahlen",
    billingDownloadPdf: "PDF herunterladen",
    billingPaymentPending: "Zahlung wird bearbeitet…",
    billingPayments: "Zahlungen",
    billingPaymentDate: "Datum",
    billingPaymentAmount: "Betrag",
    billingPaymentMethod: "Zahlungsmittel",
    billingPaymentResult: "Ergebnis",
    billingPaymentSucceeded: "Erfolgreich",
    billingPaymentFailed: "Fehlgeschlagen",
    billingPaymentRefunded: "Erstattet",
    billingPaymentFailureReason: "Grund",
    billingPaymentRetry: "Erneut versuchen",
    billingPaymentMethods: "Zahlungsmittel",
    billingCardBrand: "Karte",
    billingCardEnding: "endet auf {last4}",
    billingCardExpires: "Gültig bis {month}/{year}",
    billingCardExpiringSoon: "Läuft bald ab",
    billingCardDefault: "Standard",
    billingAddPaymentMethod: "Zahlungsmittel hinzufügen",
    billingDeletePaymentMethod: "Entfernen",
    billingDeleteMethodConfirmTitle: "Zahlungsmittel entfernen?",
    billingDeleteMethodConfirmText: "Dieses Zahlungsmittel wird endgültig entfernt.",
    billingDeleteDefaultMethodWarning: "Dies ist Ihr Standard-Zahlungsmittel und der automatische Einzug ist aktiviert. Wenn Sie es entfernen, ohne ein anderes hinzuzufügen, wird die nächste Abbuchung fehlschlagen.",
    billingMethodDeleted: "Zahlungsmittel entfernt",
    billingNoInvoices: "Noch keine Rechnungen",
    billingNoPayments: "Noch keine Zahlungen",
    billingNoPaymentMethods: "Keine Zahlungsmittel registriert",
    billingUnavailable: "Rechnungsinformationen sind vorübergehend nicht verfügbar. Bitte versuchen Sie es später erneut.",
    billingInvoiceDetail: "Rechnungsdetail",
    billingRelatedInvoice: "Rechnung",
    paymentTitle: "Zahlung",
    paymentCompany: "Unternehmen",
    paymentInvoiceNumber: "Rechnung",
    paymentAmount: "Betrag",
    paymentDueDate: "Fälligkeitsdatum",
    paymentExpiry: "Gültig bis",
    paymentPayNow: "Jetzt bezahlen",
    paymentRedirecting: "Weiterleitung zum Zahlungsanbieter...",
    paymentLinkInvalid: "Dieser Zahlungslink ist nicht mehr gültig.",
    paymentLinkInvalidHint: "Bitte kontaktieren Sie uns, wenn Sie glauben, dass es sich um einen Fehler handelt.",
    paymentLinkExpiredTitle: "Dieser Zahlungslink ist abgelaufen",
    paymentLinkExpiredDescription: "Dieser Link ist nicht mehr gültig. Bitte kehren Sie zu Ihren Rechnungen zurück, um einen neuen Zahlungslink anzufordern.",
    paymentLinkExpiredAction: "Zu meinen Rechnungen",
    paymentProcessing: "Ihre Zahlung wird verarbeitet...",
    paymentProcessingHint: "Bitte warten Sie, während wir Ihre Zahlung bestätigen.",
    paymentSucceeded: "Zahlung erfolgreich",
    paymentSucceededHint: "Ihre Zahlung wurde verarbeitet. Sie können diese Seite schliessen.",
    paymentPending: "Zahlung wird verarbeitet",
    paymentPendingHint: "Ihre Zahlung wird verarbeitet. Sie erhalten in Kürze eine Bestätigung per E-Mail.",
    paymentFailed: "Zahlung fehlgeschlagen",
    paymentFailedHint: "Ihre Zahlung konnte nicht verarbeitet werden. Bitte versuchen Sie es erneut oder kontaktieren Sie uns.",
    paymentCancelled: "Zahlung abgebrochen",
    paymentCancelledHint: "Sie haben die Zahlung abgebrochen. Es wurde kein Betrag belastet.",
    paymentStatusUnavailable: "Status nicht verfügbar",
    paymentStatusUnavailableHint: "Wir konnten den Zahlungsstatus nicht abrufen. Bitte überprüfen Sie Ihre E-Mail zur Bestätigung.",
    paymentRetry: "Zahlung erneut versuchen",
    paymentRetryExpired: "Dieser Zahlungslink ist abgelaufen. Bitte fordern Sie einen neuen über Ihre Rechnungen an.",
    paymentBackToSubscription: "Zurück zu meinem Abo",
    paymentRedirectingIn: "Weiterleitung in {0} s\u2026",
    paymentAmountPaid: "Bezahlter Betrag",
    paymentSignIn: "Anmelden",
    paymentCheckAgain: "Erneut prüfen",
    paymentNothingElseRequired: "Ihre Rechnung wurde bezahlt. Es ist nichts weiter erforderlich.",
    billingAmountDue: "Fälliger Betrag",
    billingAmountDueCount: "{count} Rechnungen",
    billingDueDate: "Fällig am {date}",
    billingViewInvoices: "Rechnungen anzeigen",
    billingPayAmount: "{amount} bezahlen",
    addonStepTitle: "Optionen zu Ihrem Abo hinzufügen",
    addonStepHint: "Diese Optionen sind mit Ihrem neuen Abo kompatibel. Sie können sie auch später hinzufügen.",
    addonStepSkip: "Überspringen",
    addonStepDone: "Weiter",
    copy: "Kopieren",
    copied: "Kopiert",
    showQrCode: "QR-Code anzeigen",
    scanToAddMeAsContact: "Scannen Sie diesen Code mit der mobilen App, um mich als Kontakt hinzuzufügen",
    myDigitalAdminCode: "Mein Digital Admin Code",
    uuidTypeMismatch: "Der UUID-Typ stimmt nicht mit dem Kontakttyp uberein (Person/Unternehmen)",
    uuidNotLinked: "Der Kontakt wurde erstellt, aber die angegebene UUID entspricht keinem registrierten Benutzer",
    chatNoRegisteredContacts: "Keine registrierten Kontakte",
    chatRegisteredContactsHint: "Ihre Kontakte mit einem Digital Admin Konto erscheinen hier",
    chatMembersUnavailable: "Dieses Unternehmen stellt seine Mitglieder nicht zur Verfugung",
    chatSelectContact: "Kontakt auswahlen",
    chatStartNewConversation: "Konversation starten",
    manualEntryMatchesWarning: "Dokumente oder Zahlungen stimmen mit dieser Bankzeile überein. Bevorzugen Sie den Abgleich über die Vorschlagsliste.",
    viewMatches: "Vorschläge anzeigen",
    directChargeWarning: "Sie erfassen eine direkte Aufwendung. Falls diese Bewegung eine bestehende Lieferantenrechnung bezahlt, verwenden Sie den Abgleich, um die Aufwendung nicht doppelt zu buchen.",
    directRevenueWarning: "Sie erfassen einen direkten Ertrag. Falls diese Bewegung eine bestehende Kundenrechnung einzieht, verwenden Sie den Abgleich, um den Ertrag nicht doppelt zu buchen.",

    // Assets (rental inventory)
    assets: "Mietobjekte",
    asset: "Mietobjekt",
    createAsset: "Mietobjekt erstellen",
    editAsset: "Mietobjekt bearbeiten",
    listAssets: "Mietobjektliste",
    viewAsset: "Mietobjekt anzeigen",
    assetName: "Bezeichnung",
    assetCode: "Code",
    assetDescription: "Beschreibung",
    defaultDepositAmount: "Standard-Kautionsbetrag",
    acquisitionValue: "Anschaffungswert",
    acquisitionDate: "Anschaffungsdatum",
    isDepreciable: "Abschreibbar",
    residualValue: "Restwert",
    depreciationYears: "Abschreibungsdauer (Jahre)",
    depreciationSection: "Abschreibung",
    assetStatusAvailable: "Verfügbar",
    assetStatusRented: "Vermietet",
    assetStatusOutOfService: "Ausser Betrieb",
    currentTenant: "Aktueller Mieter",
    rentedSince: "Vermietet seit",
    rentedUntil: "Vermietet bis",
    searchAsset: "Mietobjekt suchen",
    youWantToDeleteTheAsset: "Möchten Sie dieses Mietobjekt löschen?",
    assetDeletedSuccess: "Mietobjekt gelöscht",
    assetCreatedSuccess: "Mietobjekt erstellt",
    assetUpdatedSuccess: "Mietobjekt aktualisiert",
    assetStatusManagedByRental: "Der Status wird durch Mietvorgänge verwaltet",
    noAssetsFound: "Keine Mietobjekte gefunden",
    rentAsset: "Vermieten",
    rentThisAsset: "Dieses Objekt vermieten",
    tenant: "Mieter",
    rentalCadence: "Abrechnungshäufigkeit",
    rentalStart: "Startdatum",
    rentalEnd: "Enddatum",
    rentalDepositAmount: "Kaution",
    confirmRental: "Vermietung bestätigen",
    rentalCreatedSuccess: "Mietvertrag erstellt",
    cadenceMonthly: "Monatlich",
    cadenceQuarterly: "Vierteljährlich",
    cadenceAnnual: "Jährlich",
    cadenceDay: "Tag",
    cadenceWeek: "Woche",
    cadenceMonth: "Monat",
    cadenceQuarter: "Quartal",
    cadenceYear: "Jahr",
    rentalOptions: "Mietoptionen",
    addRentalOption: "Mietoption hinzufuegen",
    selectService: "Dienstleistung waehlen",
    rentalOption: "Mietoption",
    selectRentalOption: "Mietoption waehlen",
    noRentalOptionConfigured: "Dieses Objekt hat keine konfigurierten Mietoptionen.",
    noRentalOption: "Keine Mietoption",

    // Security deposit (caution)
    securityDeposit: "Kaution",
    depositAmount: "Kautionsbetrag",
    depositStatus: "Kautionsstatus",
    depositNone: "Keine",
    depositPending: "Ausstehend",
    depositReceived: "Erhalten",
    depositPartiallyRetained: "Teilweise einbehalten",
    depositReturned: "Zurückerstattet",
    receiveDeposit: "Empfang erfassen",
    returnDeposit: "Kaution zurückerstatten",
    retainedAmount: "Einbehaltener Betrag",
    returnedAmount: "Zurückerstatteter Betrag",
    retainedAmountHint: "Einbehaltener Betrag bei Schäden",
    amountToReturn: "Zu erstattender Betrag",
    depositReceivedSuccess: "Kautionsempfang erfasst",
    depositReturnedSuccess: "Kaution zurückerstattet",
    receivedAt: "Empfangen am",
    returnedAt: "Zurückerstattet am",
    depositMethod: "Zahlungsmethode",
    depositNote: "Bemerkung",

    // Expense reports
    expenseReports: "Spesenberichte",
    expenseReport: "Spesenbericht",
    expenseReportNumber: "Bericht Nr.",
    listExpenseReports: "Spesenberichte auflisten",
    createExpenseReport: "Spesenbericht erstellen",
    editExpenseReport: "Spesenbericht bearbeiten",
    viewExpenseReport: "Spesenbericht anzeigen",
    updateExpenseReport: "Spesenbericht aktualisieren",
    submitted: "Eingereicht",
    validated: "Validiert",
    submitExpenseReport: "Einreichen",
    rejectExpenseReport: "Zur Korrektur zurücksenden",
    validateExpenseReport: "Spesenabrechnung validieren",
    rejectionReason: "Ablehnungsgrund",
    rejectionReasonPlaceholder: "Geben Sie den Ablehnungsgrund ein...",
    rejectionReasonRequired: "Ein Ablehnungsgrund ist erforderlich",
    rejectedReason: "Ablehnungsgrund",
    reimburse: "Erstatten",
    createReimbursement: "Erstattung erstellen",
    createNewReimbursementForExpenseReport: "Neue Erstattung für Spesenbericht erstellen",
    employee: "Mitarbeiter",
    merchant: "Händler",
    expenseDate: "Ausgabedatum",
    youWantToDeleteThisExpenseReport: "Möchten Sie diesen Spesenbericht löschen?",
    processOfCreatingANewExpenseReportCompleted: "Erstellung eines neuen Spesenberichts abgeschlossen.",
    ifYouWantToSaveTheNewExpenseReport: "wenn Sie den neuen Spesenbericht speichern möchten.",
    processOfUpdatingAnExpenseReportCompleted: "Aktualisierung eines Spesenberichts abgeschlossen.",
    thisExpenseReportHasNoPayments: "Dieser Spesenbericht hat keine Erstattungen.",
    youWantToSubmitThisExpenseReport: "Möchten Sie diesen Spesenbericht einreichen?",
    expenseReportSubmittedSuccessfully: "Spesenbericht erfolgreich eingereicht.",
    youWantToValidateThisExpenseReport: "Möchten Sie diesen Spesenbericht validieren?",
    youWantToInvalidateThisExpenseReport: "Wenn Sie diesen Spesenbericht ungültig machen, werden die zugehörigen Buchungseinträge gelöscht.",
    iban: "IBAN",
    receipt: "Beleg",
    attachReceipt: "Beleg anhängen",
    removeReceipt: "Beleg entfernen",
    expenseLineDetails: "Details der Ausgabenzeile",
    newExpenseReport: "Neue Spesenabrechnung",
    descriptionCreateExpenseReport: "Bitte geben Sie die folgenden Daten ein, sie sind erforderlich, um eine neue Spesenabrechnung zu erstellen.",
    pleaseModifyFieldsFromExpenseReport: "Ändern, hinzufügen und/oder löschen Sie die Felder der Spesenabrechnung.",
    selectAnEmployee: "Mitarbeiter auswählen",
    beforeCreatingExpenseReport: "Vor der Erstellung der Spesenabrechnung",
    wouldYouLikeUploadPdfFilesToExpenseReport: "Möchten Sie PDF-Dateien für die neue Spesenabrechnung hochladen?",
    whenYouUploadPdfFilesTheyArePlacedAsExpenseReportLines: "Wenn Sie PDF-Dateien hochladen, werden diese als Beleganhänge in jeder Ausgabenzeile des Erstellungsformulars platziert.",
    expenseBelongsToExpenseReport: "Diese Ausgabe gehört zur Spesenabrechnung",
    expenseManagedFromReport: "Sie wird über die Spesenabrechnung bearbeitet und validiert.",

    // Write-off (Verlustabschreibung)
    chargedOff: "Als Verlust abgeschrieben",
    writeOff: "Als Verlust abschreiben",
    writeOffInvoice: "Rechnung als Verlust abschreiben",
    writeOffAmount: "Abschreibungsbetrag",
    writeOffDate: "Abschreibungsdatum",
    writeOffLossAccount: "Verlustkonto",
    writeOffReason: "Grund",
    writeOffReasonRequired: "Ein Grund ist erforderlich",
    writeOffConfirmMessage: "Diese Rechnung wird mit einem Verlust von abgeschrieben",
    writeOffVatCorrectionMessage: "Die MwSt. von {amount} wird korrigiert (Ziffer 235).",
    writeOffSuccess: "Rechnung erfolgreich als Verlust abgeschrieben",
    writeOffCancelConfirm: "Möchten Sie diese Verlustabschreibung stornieren?",
    writeOffCancelSuccess: "Verlustabschreibung erfolgreich storniert",
    writeOffs: "Verlustabschreibungen",
    writeOffAmountExceedsDebt: "Der Betrag übersteigt die verbleibende Schuld",
    invoiceAlreadyChargedOff: "Diese Rechnung ist bereits als Verlust abgeschrieben",

    // Expense access (employee)
    expenseAccess: "Zugang zu Spesenberichten",
    expenseAccessAuto: "Automatisch (je nach Status)",
    expenseAccessForcedOn: "Immer erlaubt",
    expenseAccessForcedOff: "Nie erlaubt",
    expenseAccessHelp: "Automatisch: erlaubt, wenn der Mitarbeiter beschäftigt ist (Entwurf oder aktiv). Immer/Nie: erzwingt den Zugang unabhängig vom Status.",
  },
};
